
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta } from "/root/front/app/pages/lp/[slug].vue?macro=true";
import { default as test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta } from "/root/front/app/pages/test.vue?macro=true";
import { default as purgeOmziTEKuqumu6ajIrQ9GQzKuSP1doNCsggDTC9jDV7IMeta } from "/root/front/app/pages/purge.vue?macro=true";
import { default as signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta } from "/root/front/app/pages/signup.vue?macro=true";
import { default as contactd9zLYnjdrYwoKV6qcj1MEz8kBEq_lvcO9E__XbrHJ0MMeta } from "/root/front/app/pages/contact.vue?macro=true";
import { default as partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta } from "/root/front/app/pages/partners.vue?macro=true";
import { default as payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta } from "/root/front/app/pages/band/payin.vue?macro=true";
import { default as indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta } from "/root/front/app/pages/draft/index.vue?macro=true";
import { default as homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta } from "/root/front/app/pages/band/homepage.vue?macro=true";
import { default as finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta } from "/root/front/app/pages/finalize-auth.vue?macro=true";
import { default as failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta } from "/root/front/app/pages/payin/failure.vue?macro=true";
import { default as indexOcKcfVR7kwoCvJtlW8F9njUpZt_X2uSW6X_t_nVRE6EMeta } from "/root/front/app/pages/band/dashboard/index.vue?macro=true";
import { default as emailsiarUfFIncqYYAU_ScSCpFr1uZiuOQp2Z3s7eI7_750IMeta } from "/root/front/app/pages/band/dashboard/emails.vue?macro=true";
import { default as dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta } from "/root/front/app/pages/band/dashboard.vue?macro=true";
import { default as parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta } from "/root/front/app/pages/band/parameter.vue?macro=true";
import { default as sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta } from "/root/front/app/pages/band/sendtrack.vue?macro=true";
import { default as reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta } from "/root/front/app/pages/reset-password.vue?macro=true";
import { default as onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta } from "/root/front/app/pages/band/onboarding.vue?macro=true";
import { default as indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta } from "/root/front/app/pages/band/shop/index.vue?macro=true";
import { default as continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta } from "/root/front/app/pages/continue-signup.vue?macro=true";
import { default as _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta } from "/root/front/app/pages/plans/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta } from "/root/front/app/pages/tools/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta } from "/root/front/app/pages/charts/[...slug].vue?macro=true";
import { default as recap1qbBLfO_DYTz2IzLk_6f_4FfnHqKI4PdB76kKxzfpqoMeta } from "/root/front/app/pages/draft/[id]/index/recap.vue?macro=true";
import { default as trackDQvTO_0bol8JSIUIjG1jOdnmVGoS2RSZvaLiPenTdT8Meta } from "/root/front/app/pages/draft/[id]/index/track.vue?macro=true";
import { default as messagesqwx1lFVgix_mh_Z5scPnadN6hWaHw7CL3_LhatvyzZ8Meta } from "/root/front/app/pages/draft/[id]/index/messages.vue?macro=true";
import { default as shared_45musicyxbW8MWYWgL7zp7tIsHxDRwmHrlKJd47_GuAhvc2QDgMeta } from "/root/front/app/pages/draft/[id]/index/shared-music.vue?macro=true";
import { default as indexZUDso6Dwi2C5aRahM3ZErcx3drqYBWGZVh2_Vq_fAesMeta } from "/root/front/app/pages/draft/[id]/index.vue?macro=true";
import { default as create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta } from "/root/front/app/pages/band/create-draft.vue?macro=true";
import { default as indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta } from "/root/front/app/pages/band/signup/index.vue?macro=true";
import { default as influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta } from "/root/front/app/pages/draft/influencers.vue?macro=true";
import { default as indexVXawq9fKq4tQz8LBk_ppUkTt_PV5myRjoVxxGCyDHv0Meta } from "/root/front/app/pages/influencer/wallet/index.vue?macro=true";
import { default as transferyyg4zmjIhvs2BRbcG33tOpRQqjaQPtjP9KGVnY2dg_IMeta } from "/root/front/app/pages/influencer/wallet/transfer.vue?macro=true";
import { default as withdrawZiZiVO8IuSKYhLzAws6SyAFtpDgMw_PWljkaAmLQ6DAMeta } from "/root/front/app/pages/influencer/wallet/withdraw.vue?macro=true";
import { default as walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta } from "/root/front/app/pages/influencer/wallet.vue?macro=true";
import { default as indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta } from "/root/front/app/pages/band/profile/index.vue?macro=true";
import { default as post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta } from "/root/front/app/pages/draft/[id]/post3ds.vue?macro=true";
import { default as cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta } from "/root/front/app/pages/influencer/cashout.vue?macro=true";
import { default as retryY0hiZWust7lEJGOQVOpFvWy_FjcBdk8VyFRgSgoNABYMeta } from "/root/front/app/pages/payin/paypal/retry.vue?macro=true";
import { default as createznZmYzSrEKkGwt8fQpdqdQMRfFojNu1fKBoCxPRbg0UMeta } from "/root/front/app/pages/band/profile/create.vue?macro=true";
import { default as deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta } from "/root/front/app/pages/band/profile/delete.vue?macro=true";
import { default as selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta } from "/root/front/app/pages/band/profile/select.vue?macro=true";
import { default as indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta } from "/root/front/app/pages/band/referral/index.vue?macro=true";
import { default as finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta } from "/root/front/app/pages/band/shop/finalized.vue?macro=true";
import { default as activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta } from "/root/front/app/pages/influencer/activate.vue?macro=true";
import { default as trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta } from "/root/front/app/pages/spotify/share/track.vue?macro=true";
import { default as _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta } from "/root/front/app/pages/band/referral/[code].vue?macro=true";
import { default as finalized9KYfedAWD8Na6Zc3eqdzafliOvEtzhmdJAxzrgB754UMeta } from "/root/front/app/pages/draft/[id]/finalized.vue?macro=true";
import { default as dashboard_Gpif0FswMsAGh98lwAaumBTUyHIrhn11r2eG3REOHQMeta } from "/root/front/app/pages/influencer/dashboard.vue?macro=true";
import { default as fansQEBn5Sy_ukxQgGFlRM1TlQGNvE_rcrYu_IX7gbvBxSUMeta } from "/root/front/app/pages/influencer/list/fans.vue?macro=true";
import { default as parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta } from "/root/front/app/pages/influencer/parameter.vue?macro=true";
import { default as _91id_93QPuo0kpudZK4G2lE1xIe4j8V1EoVWghGC0HYnk2V60UMeta } from "/root/front/app/pages/agency/favorites/[id].vue?macro=true";
import { default as discoveryX8yYlS35nBzjm71lmiedBqdM_JHWk2_J2iDRNULGj_gMeta } from "/root/front/app/pages/band/signup/discovery.vue?macro=true";
import { default as indexsXMuN6ssrVK59bO2G2_S_7XDxr1gp7VnjxtfgMBgxQQMeta } from "/root/front/app/pages/agency/favorites/index.vue?macro=true";
import { default as index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta } from "/root/front/app/pages/draft/[id]/influencers/index.vue?macro=true";
import { default as lists3D1hpJUQNQ_rvp_sKD5TEgQpNCCoaN0_oJw7GdA_XQcMeta } from "/root/front/app/pages/draft/[id]/influencers/lists.vue?macro=true";
import { default as loadingWDfRrab2BWmVmSVTMPkEdtSVGciGOZCh5oR48S3TqUQMeta } from "/root/front/app/pages/draft/[id]/influencers/loading.vue?macro=true";
import { default as influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta } from "/root/front/app/pages/draft/[id]/influencers.vue?macro=true";
import { default as popularSa42PRzALGyJaFqy1oekk12ekQfQD01aVn5yMSjsEyMMeta } from "/root/front/app/pages/influencer/list/popular.vue?macro=true";
import { default as indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta } from "/root/front/app/pages/influencer/signup/index.vue?macro=true";
import { default as indexc6XD8jl2aNunuBIbz_BXVE_tpyJRkvSCINMa7q8jH7UMeta } from "/root/front/app/pages/influencer/widget/index.vue?macro=true";
import { default as edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta } from "/root/front/app/pages/band/profile/[slug]/edit.vue?macro=true";
import { default as indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta } from "/root/front/app/pages/influencer/profile/index.vue?macro=true";
import { default as biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta } from "/root/front/app/pages/influencer/signup/v2/bio.vue?macro=true";
import { default as _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta } from "/root/front/app/pages/influencer/widget/[slug].vue?macro=true";
import { default as index8RIUC_wAKHsE1Hq4sBbSYBCxQY4s_ri55rwKaVtQ_OMMeta } from "/root/front/app/pages/band/profile/[slug]/index.vue?macro=true";
import { default as indexlJfYtYeozRvzroOv9svHe1mG18jKlVyDAGsbNVSS1h8Meta } from "/root/front/app/pages/influencer/list/all/index.vue?macro=true";
import { default as typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta } from "/root/front/app/pages/influencer/signup/v2/type.vue?macro=true";
import { default as index5xRLWI5zfbQ_9E7Mz_cNe5pBqpOXx0CPGYUjQdjRpmAMeta } from "/root/front/app/pages/band/edit/track/[id]/index.vue?macro=true";
import { default as stripe7xrSHFhrmd7s580gAkCurAr6N5sfrgTRQzAW8Ml6Gv8Meta } from "/root/front/app/pages/band/shop/processing/stripe.vue?macro=true";
import { default as discoveryDiHl5Tc3OuE8EwuvLmzdqXCggX_IUOu_GHmeoe7bge0Meta } from "/root/front/app/pages/influencer/signup/discovery.vue?macro=true";
import { default as genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta } from "/root/front/app/pages/influencer/signup/v2/genres.vue?macro=true";
import { default as stripeDlFOmDkU2ZUx9YdnlKWBkxTEwE0iKgUEsdKhPM2yhgcMeta } from "/root/front/app/pages/draft/[id]/processing/stripe.vue?macro=true";
import { default as new_45arrivalszenIr1edMhMWaS8ffGrTyOaLHYlkNyC_tfon04NcFM8Meta } from "/root/front/app/pages/influencer/list/new-arrivals.vue?macro=true";
import { default as pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta } from "/root/front/app/pages/influencer/signup/v2/picture.vue?macro=true";
import { default as _91_46_46_46slug_93cDMrn2_sxiRzRnUQNF19Vj_jTIi2pTbrqOEMqeBfRIoMeta } from "/root/front/app/pages/influencer/list/tags/[...slug].vue?macro=true";
import { default as editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta } from "/root/front/app/pages/influencer/profile/[slug]/edit.vue?macro=true";
import { default as index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta } from "/root/front/app/pages/influencer/profile/[slug]/index.vue?macro=true";
import { default as name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta } from "/root/front/app/pages/influencer/signup/v2/name-country.vue?macro=true";
import { default as _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta } from "/root/front/app/pages/influencer/widget/redirect/[slug].vue?macro=true";
import { default as _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta } from "/root/front/app/pages/band/signup/referral/agency/[code].vue?macro=true";
import { default as opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta } from "/root/front/app/pages/influencer/signup/v2/opportunities.vue?macro=true";
import { default as website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta } from "/root/front/app/pages/influencer/signup/v2/website-links.vue?macro=true";
import { default as similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta } from "/root/front/app/pages/influencer/signup/v2/similar-artists.vue?macro=true";
import { default as _91code_93wxkzxNKx283YR_k6j4IZz2kfaSorSJOeg6ig9OKmnmgMeta } from "/root/front/app/pages/band/signup/referral/influencer/[code].vue?macro=true";
import { default as lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta } from "/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue?macro=true";
import { default as indexguGuGyRmcSFEYf8UoiGcNZnk3jWOWekdrdnWzDdbl6IMeta } from "/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "index___en",
    path: "/en/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "index___fr",
    path: "/fr/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "index___de",
    path: "/de/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "index___es",
    path: "/es/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "index___pt",
    path: "/pt/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "index___it",
    path: "/it/",
    meta: { ...(_91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {}), ...{"middleware":"index-redirection","layout":false} },
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "test___en",
    path: "/en/test/",
    meta: test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta || {},
    component: () => import("/root/front/app/pages/test.vue")
  },
  {
    name: "test___fr",
    path: "/fr/test/",
    meta: test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta || {},
    component: () => import("/root/front/app/pages/test.vue")
  },
  {
    name: "test___de",
    path: "/de/test/",
    meta: test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta || {},
    component: () => import("/root/front/app/pages/test.vue")
  },
  {
    name: "test___es",
    path: "/es/test/",
    meta: test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta || {},
    component: () => import("/root/front/app/pages/test.vue")
  },
  {
    name: "test___pt",
    path: "/pt/test/",
    meta: test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta || {},
    component: () => import("/root/front/app/pages/test.vue")
  },
  {
    name: "test___it",
    path: "/it/test/",
    meta: test9lU03xbrTQubWn_rCD6SJHQtd3OGgL_WYJN_O_ciC3oMeta || {},
    component: () => import("/root/front/app/pages/test.vue")
  },
  {
    name: "purge___en",
    path: "/en/purge/",
    component: () => import("/root/front/app/pages/purge.vue")
  },
  {
    name: "purge___fr",
    path: "/fr/purge/",
    component: () => import("/root/front/app/pages/purge.vue")
  },
  {
    name: "purge___de",
    path: "/de/purge/",
    component: () => import("/root/front/app/pages/purge.vue")
  },
  {
    name: "purge___es",
    path: "/es/purge/",
    component: () => import("/root/front/app/pages/purge.vue")
  },
  {
    name: "purge___pt",
    path: "/pt/purge/",
    component: () => import("/root/front/app/pages/purge.vue")
  },
  {
    name: "purge___it",
    path: "/it/purge/",
    component: () => import("/root/front/app/pages/purge.vue")
  },
  {
    name: "signup___en",
    path: "/en/signup/",
    meta: signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta || {},
    component: () => import("/root/front/app/pages/signup.vue")
  },
  {
    name: "signup___fr",
    path: "/fr/signup/",
    meta: signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta || {},
    component: () => import("/root/front/app/pages/signup.vue")
  },
  {
    name: "signup___de",
    path: "/de/signup/",
    meta: signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta || {},
    component: () => import("/root/front/app/pages/signup.vue")
  },
  {
    name: "signup___es",
    path: "/es/signup/",
    meta: signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta || {},
    component: () => import("/root/front/app/pages/signup.vue")
  },
  {
    name: "signup___pt",
    path: "/pt/signup/",
    meta: signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta || {},
    component: () => import("/root/front/app/pages/signup.vue")
  },
  {
    name: "signup___it",
    path: "/it/signup/",
    meta: signupsX8xP_zx0Zp7D9FHklulRxcEVfZa6FlQlHc1SaNdhmQMeta || {},
    component: () => import("/root/front/app/pages/signup.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact/",
    component: () => import("/root/front/app/pages/contact.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact/",
    component: () => import("/root/front/app/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/contact/",
    component: () => import("/root/front/app/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact/",
    component: () => import("/root/front/app/pages/contact.vue")
  },
  {
    name: "contact___pt",
    path: "/pt/contact/",
    component: () => import("/root/front/app/pages/contact.vue")
  },
  {
    name: "contact___it",
    path: "/it/contact/",
    component: () => import("/root/front/app/pages/contact.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners/",
    meta: partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta || {},
    component: () => import("/root/front/app/pages/partners.vue")
  },
  {
    name: "partners___fr",
    path: "/fr/partners/",
    meta: partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta || {},
    component: () => import("/root/front/app/pages/partners.vue")
  },
  {
    name: "partners___de",
    path: "/de/partners/",
    meta: partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta || {},
    component: () => import("/root/front/app/pages/partners.vue")
  },
  {
    name: "partners___es",
    path: "/es/partners/",
    meta: partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta || {},
    component: () => import("/root/front/app/pages/partners.vue")
  },
  {
    name: "partners___pt",
    path: "/pt/partners/",
    meta: partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta || {},
    component: () => import("/root/front/app/pages/partners.vue")
  },
  {
    name: "partners___it",
    path: "/it/partners/",
    meta: partnersyvdmYUCUms93t_iA7tIcfrj7eoh18__VXVu_E_tlepcMeta || {},
    component: () => import("/root/front/app/pages/partners.vue")
  },
  {
    name: "lp-slug___en",
    path: "/en/lp/:slug()/",
    meta: _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {},
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "lp-slug___fr",
    path: "/fr/lp/:slug()/",
    meta: _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {},
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "lp-slug___de",
    path: "/de/lp/:slug()/",
    meta: _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {},
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "lp-slug___es",
    path: "/es/lp/:slug()/",
    meta: _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {},
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "lp-slug___pt",
    path: "/pt/lp/:slug()/",
    meta: _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {},
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "lp-slug___it",
    path: "/it/lp/:slug()/",
    meta: _91slug_93OxXxQRf8MqGebaLD2voY6TZ8cpuz4TagJQFAezhOID8Meta || {},
    component: () => import("/root/front/app/pages/lp/[slug].vue")
  },
  {
    name: "band-payin___en",
    path: "/en/band/payin/",
    meta: payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta || {},
    component: () => import("/root/front/app/pages/band/payin.vue")
  },
  {
    name: "band-payin___fr",
    path: "/fr/band/payin/",
    meta: payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta || {},
    component: () => import("/root/front/app/pages/band/payin.vue")
  },
  {
    name: "band-payin___de",
    path: "/de/band/payin/",
    meta: payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta || {},
    component: () => import("/root/front/app/pages/band/payin.vue")
  },
  {
    name: "band-payin___es",
    path: "/es/band/payin/",
    meta: payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta || {},
    component: () => import("/root/front/app/pages/band/payin.vue")
  },
  {
    name: "band-payin___pt",
    path: "/pt/band/payin/",
    meta: payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta || {},
    component: () => import("/root/front/app/pages/band/payin.vue")
  },
  {
    name: "band-payin___it",
    path: "/it/band/payin/",
    meta: payinD7yaLnpYCQDyaSbnmeZj9n68NFdfsW5p2baWOw0_hRcMeta || {},
    component: () => import("/root/front/app/pages/band/payin.vue")
  },
  {
    name: "draft___en",
    path: "/en/draft/",
    meta: indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta || {},
    component: () => import("/root/front/app/pages/draft/index.vue")
  },
  {
    name: "draft___fr",
    path: "/fr/draft/",
    meta: indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta || {},
    component: () => import("/root/front/app/pages/draft/index.vue")
  },
  {
    name: "draft___de",
    path: "/de/draft/",
    meta: indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta || {},
    component: () => import("/root/front/app/pages/draft/index.vue")
  },
  {
    name: "draft___es",
    path: "/es/draft/",
    meta: indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta || {},
    component: () => import("/root/front/app/pages/draft/index.vue")
  },
  {
    name: "draft___pt",
    path: "/pt/draft/",
    meta: indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta || {},
    component: () => import("/root/front/app/pages/draft/index.vue")
  },
  {
    name: "draft___it",
    path: "/it/draft/",
    meta: indexJ1JNhHKhZDiL3LEys9x9jfpyW6gFdNkKQOkJG4BQJJwMeta || {},
    component: () => import("/root/front/app/pages/draft/index.vue")
  },
  {
    name: "band-homepage___en",
    path: "/en/band/homepage/",
    meta: homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta || {},
    component: () => import("/root/front/app/pages/band/homepage.vue")
  },
  {
    name: "band-homepage___fr",
    path: "/fr/band/homepage/",
    meta: homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta || {},
    component: () => import("/root/front/app/pages/band/homepage.vue")
  },
  {
    name: "band-homepage___de",
    path: "/de/band/homepage/",
    meta: homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta || {},
    component: () => import("/root/front/app/pages/band/homepage.vue")
  },
  {
    name: "band-homepage___es",
    path: "/es/band/homepage/",
    meta: homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta || {},
    component: () => import("/root/front/app/pages/band/homepage.vue")
  },
  {
    name: "band-homepage___pt",
    path: "/pt/band/homepage/",
    meta: homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta || {},
    component: () => import("/root/front/app/pages/band/homepage.vue")
  },
  {
    name: "band-homepage___it",
    path: "/it/band/homepage/",
    meta: homepagekYMxSSyPOubxVDl_8EXYOT9lnCJKO05fNH9JR6ETQxoMeta || {},
    component: () => import("/root/front/app/pages/band/homepage.vue")
  },
  {
    name: "finalize-auth___en",
    path: "/en/finalize-auth/",
    meta: finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta || {},
    component: () => import("/root/front/app/pages/finalize-auth.vue")
  },
  {
    name: "finalize-auth___fr",
    path: "/fr/finalize-auth/",
    meta: finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta || {},
    component: () => import("/root/front/app/pages/finalize-auth.vue")
  },
  {
    name: "finalize-auth___de",
    path: "/de/finalize-auth/",
    meta: finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta || {},
    component: () => import("/root/front/app/pages/finalize-auth.vue")
  },
  {
    name: "finalize-auth___es",
    path: "/es/finalize-auth/",
    meta: finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta || {},
    component: () => import("/root/front/app/pages/finalize-auth.vue")
  },
  {
    name: "finalize-auth___pt",
    path: "/pt/finalize-auth/",
    meta: finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta || {},
    component: () => import("/root/front/app/pages/finalize-auth.vue")
  },
  {
    name: "finalize-auth___it",
    path: "/it/finalize-auth/",
    meta: finalize_45authTYTvxfrRC2ZbZq8m35Qu_qUwrKXD1Oe6ZidrTPVQeosMeta || {},
    component: () => import("/root/front/app/pages/finalize-auth.vue")
  },
  {
    name: "payin-failure___en",
    path: "/en/payin/failure/",
    meta: failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta || {},
    component: () => import("/root/front/app/pages/payin/failure.vue")
  },
  {
    name: "payin-failure___fr",
    path: "/fr/payin/failure/",
    meta: failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta || {},
    component: () => import("/root/front/app/pages/payin/failure.vue")
  },
  {
    name: "payin-failure___de",
    path: "/de/payin/failure/",
    meta: failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta || {},
    component: () => import("/root/front/app/pages/payin/failure.vue")
  },
  {
    name: "payin-failure___es",
    path: "/es/payin/failure/",
    meta: failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta || {},
    component: () => import("/root/front/app/pages/payin/failure.vue")
  },
  {
    name: "payin-failure___pt",
    path: "/pt/payin/failure/",
    meta: failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta || {},
    component: () => import("/root/front/app/pages/payin/failure.vue")
  },
  {
    name: "payin-failure___it",
    path: "/it/payin/failure/",
    meta: failure8onQgcs66Ks_jdOxYwveVqOGcnQaPH956zj6jUsVwk4Meta || {},
    component: () => import("/root/front/app/pages/payin/failure.vue")
  },
  {
    name: dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta?.name,
    path: "/en/band/dashboard/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/band/dashboard.vue"),
    children: [
  {
    name: "band-dashboard___en",
    path: "",
    component: () => import("/root/front/app/pages/band/dashboard/index.vue")
  },
  {
    name: "band-dashboard-emails___en",
    path: "emails/",
    component: () => import("/root/front/app/pages/band/dashboard/emails.vue")
  }
]
  },
  {
    name: dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta?.name,
    path: "/fr/band/dashboard/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/band/dashboard.vue"),
    children: [
  {
    name: "band-dashboard___fr",
    path: "",
    component: () => import("/root/front/app/pages/band/dashboard/index.vue")
  },
  {
    name: "band-dashboard-emails___fr",
    path: "emails/",
    component: () => import("/root/front/app/pages/band/dashboard/emails.vue")
  }
]
  },
  {
    name: dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta?.name,
    path: "/de/band/dashboard/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/band/dashboard.vue"),
    children: [
  {
    name: "band-dashboard___de",
    path: "",
    component: () => import("/root/front/app/pages/band/dashboard/index.vue")
  },
  {
    name: "band-dashboard-emails___de",
    path: "emails/",
    component: () => import("/root/front/app/pages/band/dashboard/emails.vue")
  }
]
  },
  {
    name: dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta?.name,
    path: "/es/band/dashboard/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/band/dashboard.vue"),
    children: [
  {
    name: "band-dashboard___es",
    path: "",
    component: () => import("/root/front/app/pages/band/dashboard/index.vue")
  },
  {
    name: "band-dashboard-emails___es",
    path: "emails/",
    component: () => import("/root/front/app/pages/band/dashboard/emails.vue")
  }
]
  },
  {
    name: dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta?.name,
    path: "/pt/band/dashboard/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/band/dashboard.vue"),
    children: [
  {
    name: "band-dashboard___pt",
    path: "",
    component: () => import("/root/front/app/pages/band/dashboard/index.vue")
  },
  {
    name: "band-dashboard-emails___pt",
    path: "emails/",
    component: () => import("/root/front/app/pages/band/dashboard/emails.vue")
  }
]
  },
  {
    name: dashboard_ikXETKD4XmUriij6FDndcejUNSWEUfIUC1udIUifjcMeta?.name,
    path: "/it/band/dashboard/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/band/dashboard.vue"),
    children: [
  {
    name: "band-dashboard___it",
    path: "",
    component: () => import("/root/front/app/pages/band/dashboard/index.vue")
  },
  {
    name: "band-dashboard-emails___it",
    path: "emails/",
    component: () => import("/root/front/app/pages/band/dashboard/emails.vue")
  }
]
  },
  {
    name: "band-parameter___en",
    path: "/en/band/parameter/",
    meta: parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta || {},
    component: () => import("/root/front/app/pages/band/parameter.vue")
  },
  {
    name: "band-parameter___fr",
    path: "/fr/band/parameter/",
    meta: parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta || {},
    component: () => import("/root/front/app/pages/band/parameter.vue")
  },
  {
    name: "band-parameter___de",
    path: "/de/band/parameter/",
    meta: parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta || {},
    component: () => import("/root/front/app/pages/band/parameter.vue")
  },
  {
    name: "band-parameter___es",
    path: "/es/band/parameter/",
    meta: parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta || {},
    component: () => import("/root/front/app/pages/band/parameter.vue")
  },
  {
    name: "band-parameter___pt",
    path: "/pt/band/parameter/",
    meta: parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta || {},
    component: () => import("/root/front/app/pages/band/parameter.vue")
  },
  {
    name: "band-parameter___it",
    path: "/it/band/parameter/",
    meta: parametert6IN83fR7ah76qf_jJKcHYTPrXaN60FwNm1R4Du8a2UMeta || {},
    component: () => import("/root/front/app/pages/band/parameter.vue")
  },
  {
    name: "band-sendtrack___en",
    path: "/en/band/sendtrack/",
    meta: sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta || {},
    component: () => import("/root/front/app/pages/band/sendtrack.vue")
  },
  {
    name: "band-sendtrack___fr",
    path: "/fr/band/sendtrack/",
    meta: sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta || {},
    component: () => import("/root/front/app/pages/band/sendtrack.vue")
  },
  {
    name: "band-sendtrack___de",
    path: "/de/band/sendtrack/",
    meta: sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta || {},
    component: () => import("/root/front/app/pages/band/sendtrack.vue")
  },
  {
    name: "band-sendtrack___es",
    path: "/es/band/sendtrack/",
    meta: sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta || {},
    component: () => import("/root/front/app/pages/band/sendtrack.vue")
  },
  {
    name: "band-sendtrack___pt",
    path: "/pt/band/sendtrack/",
    meta: sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta || {},
    component: () => import("/root/front/app/pages/band/sendtrack.vue")
  },
  {
    name: "band-sendtrack___it",
    path: "/it/band/sendtrack/",
    meta: sendtrackYvbWloDLLBVtRPZA7F6pDy_Gx9ws5j0E252txLzb2VUMeta || {},
    component: () => import("/root/front/app/pages/band/sendtrack.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password/",
    meta: reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta || {},
    component: () => import("/root/front/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password/",
    meta: reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta || {},
    component: () => import("/root/front/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/reset-password/",
    meta: reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta || {},
    component: () => import("/root/front/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___es",
    path: "/es/reset-password/",
    meta: reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta || {},
    component: () => import("/root/front/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___pt",
    path: "/pt/reset-password/",
    meta: reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta || {},
    component: () => import("/root/front/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___it",
    path: "/it/reset-password/",
    meta: reset_45passwordo64ZkXPk9144kDFWPxcabNgoz_tBR_W9bfaR90FX25cMeta || {},
    component: () => import("/root/front/app/pages/reset-password.vue")
  },
  {
    name: "band-onboarding___en",
    path: "/en/band/onboarding/",
    meta: onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta || {},
    component: () => import("/root/front/app/pages/band/onboarding.vue")
  },
  {
    name: "band-onboarding___fr",
    path: "/fr/band/onboarding/",
    meta: onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta || {},
    component: () => import("/root/front/app/pages/band/onboarding.vue")
  },
  {
    name: "band-onboarding___de",
    path: "/de/band/onboarding/",
    meta: onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta || {},
    component: () => import("/root/front/app/pages/band/onboarding.vue")
  },
  {
    name: "band-onboarding___es",
    path: "/es/band/onboarding/",
    meta: onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta || {},
    component: () => import("/root/front/app/pages/band/onboarding.vue")
  },
  {
    name: "band-onboarding___pt",
    path: "/pt/band/onboarding/",
    meta: onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta || {},
    component: () => import("/root/front/app/pages/band/onboarding.vue")
  },
  {
    name: "band-onboarding___it",
    path: "/it/band/onboarding/",
    meta: onboardingsNyGbDV2HHfFk_hUZLHskMl5624rfTJNzQ33Zn7bC_QMeta || {},
    component: () => import("/root/front/app/pages/band/onboarding.vue")
  },
  {
    name: "band-shop___en",
    path: "/en/band/shop/",
    meta: indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta || {},
    component: () => import("/root/front/app/pages/band/shop/index.vue")
  },
  {
    name: "band-shop___fr",
    path: "/fr/band/shop/",
    meta: indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta || {},
    component: () => import("/root/front/app/pages/band/shop/index.vue")
  },
  {
    name: "band-shop___de",
    path: "/de/band/shop/",
    meta: indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta || {},
    component: () => import("/root/front/app/pages/band/shop/index.vue")
  },
  {
    name: "band-shop___es",
    path: "/es/band/shop/",
    meta: indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta || {},
    component: () => import("/root/front/app/pages/band/shop/index.vue")
  },
  {
    name: "band-shop___pt",
    path: "/pt/band/shop/",
    meta: indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta || {},
    component: () => import("/root/front/app/pages/band/shop/index.vue")
  },
  {
    name: "band-shop___it",
    path: "/it/band/shop/",
    meta: indexZrJO7NYMGIrtLKX_C97gE1r64dbFWcllnZBjVIJ_AfUMeta || {},
    component: () => import("/root/front/app/pages/band/shop/index.vue")
  },
  {
    name: "continue-signup___en",
    path: "/en/continue-signup/",
    meta: continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta || {},
    component: () => import("/root/front/app/pages/continue-signup.vue")
  },
  {
    name: "continue-signup___fr",
    path: "/fr/continue-signup/",
    meta: continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta || {},
    component: () => import("/root/front/app/pages/continue-signup.vue")
  },
  {
    name: "continue-signup___de",
    path: "/de/continue-signup/",
    meta: continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta || {},
    component: () => import("/root/front/app/pages/continue-signup.vue")
  },
  {
    name: "continue-signup___es",
    path: "/es/continue-signup/",
    meta: continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta || {},
    component: () => import("/root/front/app/pages/continue-signup.vue")
  },
  {
    name: "continue-signup___pt",
    path: "/pt/continue-signup/",
    meta: continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta || {},
    component: () => import("/root/front/app/pages/continue-signup.vue")
  },
  {
    name: "continue-signup___it",
    path: "/it/continue-signup/",
    meta: continue_45signupmuk2H78r44a_yCNmsm2ULEtjCQYYF6Wbf5tYgIW75NIMeta || {},
    component: () => import("/root/front/app/pages/continue-signup.vue")
  },
  {
    name: "plans-slug___en",
    path: "/en/plans/:slug(.*)*/",
    meta: _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta || {},
    component: () => import("/root/front/app/pages/plans/[...slug].vue")
  },
  {
    name: "plans-slug___fr",
    path: "/fr/plans/:slug(.*)*/",
    meta: _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta || {},
    component: () => import("/root/front/app/pages/plans/[...slug].vue")
  },
  {
    name: "plans-slug___de",
    path: "/de/plans/:slug(.*)*/",
    meta: _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta || {},
    component: () => import("/root/front/app/pages/plans/[...slug].vue")
  },
  {
    name: "plans-slug___es",
    path: "/es/plans/:slug(.*)*/",
    meta: _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta || {},
    component: () => import("/root/front/app/pages/plans/[...slug].vue")
  },
  {
    name: "plans-slug___pt",
    path: "/pt/plans/:slug(.*)*/",
    meta: _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta || {},
    component: () => import("/root/front/app/pages/plans/[...slug].vue")
  },
  {
    name: "plans-slug___it",
    path: "/it/plans/:slug(.*)*/",
    meta: _91_46_46_46slug_930pObuWqWDT5O5G7ua4zceXaoutQKLEKApsnFCTCvyAAMeta || {},
    component: () => import("/root/front/app/pages/plans/[...slug].vue")
  },
  {
    name: "tools-slug___en",
    path: "/en/tools/:slug(.*)*/",
    meta: _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta || {},
    component: () => import("/root/front/app/pages/tools/[...slug].vue")
  },
  {
    name: "tools-slug___fr",
    path: "/fr/tools/:slug(.*)*/",
    meta: _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta || {},
    component: () => import("/root/front/app/pages/tools/[...slug].vue")
  },
  {
    name: "tools-slug___de",
    path: "/de/tools/:slug(.*)*/",
    meta: _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta || {},
    component: () => import("/root/front/app/pages/tools/[...slug].vue")
  },
  {
    name: "tools-slug___es",
    path: "/es/tools/:slug(.*)*/",
    meta: _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta || {},
    component: () => import("/root/front/app/pages/tools/[...slug].vue")
  },
  {
    name: "tools-slug___pt",
    path: "/pt/tools/:slug(.*)*/",
    meta: _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta || {},
    component: () => import("/root/front/app/pages/tools/[...slug].vue")
  },
  {
    name: "tools-slug___it",
    path: "/it/tools/:slug(.*)*/",
    meta: _91_46_46_46slug_93___kVq4l4C5oTj3fvrWZKmDzuixuyJsEAmBgW8cJREoMeta || {},
    component: () => import("/root/front/app/pages/tools/[...slug].vue")
  },
  {
    name: "charts-slug___en",
    path: "/en/charts/:slug(.*)*/",
    meta: _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta || {},
    component: () => import("/root/front/app/pages/charts/[...slug].vue")
  },
  {
    name: "charts-slug___fr",
    path: "/fr/charts/:slug(.*)*/",
    meta: _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta || {},
    component: () => import("/root/front/app/pages/charts/[...slug].vue")
  },
  {
    name: "charts-slug___de",
    path: "/de/charts/:slug(.*)*/",
    meta: _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta || {},
    component: () => import("/root/front/app/pages/charts/[...slug].vue")
  },
  {
    name: "charts-slug___es",
    path: "/es/charts/:slug(.*)*/",
    meta: _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta || {},
    component: () => import("/root/front/app/pages/charts/[...slug].vue")
  },
  {
    name: "charts-slug___pt",
    path: "/pt/charts/:slug(.*)*/",
    meta: _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta || {},
    component: () => import("/root/front/app/pages/charts/[...slug].vue")
  },
  {
    name: "charts-slug___it",
    path: "/it/charts/:slug(.*)*/",
    meta: _91_46_46_46slug_93bWVRWwchb6C0vfMuvRLfxyTO_nG5_KQYH7srCEV_ofIMeta || {},
    component: () => import("/root/front/app/pages/charts/[...slug].vue")
  },
  {
    name: "draft-id___en",
    path: "/en/draft/:id()/",
    meta: {"middleware":["is-logged-in","is-band","draft-id","draft-influencers","draft-step"]},
    component: () => import("/root/front/app/pages/draft/[id]/index.vue"),
    children: [
  {
    name: "draft-id-index-recap___en",
    path: "recap/",
    meta: {"middleware":["draft-influencers","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/recap.vue")
  },
  {
    name: "draft-id-index-track___en",
    path: "track/",
    component: () => import("/root/front/app/pages/draft/[id]/index/track.vue")
  },
  {
    name: "draft-id-index-messages___en",
    path: "messages/",
    component: () => import("/root/front/app/pages/draft/[id]/index/messages.vue")
  },
  {
    name: "draft-id-index-shared-music___en",
    path: "shared-music/",
    meta: {"middleware":["draft-shared-music"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/shared-music.vue")
  }
]
  },
  {
    name: "draft-id___fr",
    path: "/fr/draft/:id()/",
    meta: {"middleware":["is-logged-in","is-band","draft-id","draft-influencers","draft-step"]},
    component: () => import("/root/front/app/pages/draft/[id]/index.vue"),
    children: [
  {
    name: "draft-id-index-recap___fr",
    path: "recap/",
    meta: {"middleware":["draft-influencers","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/recap.vue")
  },
  {
    name: "draft-id-index-track___fr",
    path: "track/",
    component: () => import("/root/front/app/pages/draft/[id]/index/track.vue")
  },
  {
    name: "draft-id-index-messages___fr",
    path: "messages/",
    component: () => import("/root/front/app/pages/draft/[id]/index/messages.vue")
  },
  {
    name: "draft-id-index-shared-music___fr",
    path: "shared-music/",
    meta: {"middleware":["draft-shared-music"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/shared-music.vue")
  }
]
  },
  {
    name: "draft-id___de",
    path: "/de/draft/:id()/",
    meta: {"middleware":["is-logged-in","is-band","draft-id","draft-influencers","draft-step"]},
    component: () => import("/root/front/app/pages/draft/[id]/index.vue"),
    children: [
  {
    name: "draft-id-index-recap___de",
    path: "recap/",
    meta: {"middleware":["draft-influencers","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/recap.vue")
  },
  {
    name: "draft-id-index-track___de",
    path: "track/",
    component: () => import("/root/front/app/pages/draft/[id]/index/track.vue")
  },
  {
    name: "draft-id-index-messages___de",
    path: "messages/",
    component: () => import("/root/front/app/pages/draft/[id]/index/messages.vue")
  },
  {
    name: "draft-id-index-shared-music___de",
    path: "shared-music/",
    meta: {"middleware":["draft-shared-music"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/shared-music.vue")
  }
]
  },
  {
    name: "draft-id___es",
    path: "/es/draft/:id()/",
    meta: {"middleware":["is-logged-in","is-band","draft-id","draft-influencers","draft-step"]},
    component: () => import("/root/front/app/pages/draft/[id]/index.vue"),
    children: [
  {
    name: "draft-id-index-recap___es",
    path: "recap/",
    meta: {"middleware":["draft-influencers","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/recap.vue")
  },
  {
    name: "draft-id-index-track___es",
    path: "track/",
    component: () => import("/root/front/app/pages/draft/[id]/index/track.vue")
  },
  {
    name: "draft-id-index-messages___es",
    path: "messages/",
    component: () => import("/root/front/app/pages/draft/[id]/index/messages.vue")
  },
  {
    name: "draft-id-index-shared-music___es",
    path: "shared-music/",
    meta: {"middleware":["draft-shared-music"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/shared-music.vue")
  }
]
  },
  {
    name: "draft-id___pt",
    path: "/pt/draft/:id()/",
    meta: {"middleware":["is-logged-in","is-band","draft-id","draft-influencers","draft-step"]},
    component: () => import("/root/front/app/pages/draft/[id]/index.vue"),
    children: [
  {
    name: "draft-id-index-recap___pt",
    path: "recap/",
    meta: {"middleware":["draft-influencers","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/recap.vue")
  },
  {
    name: "draft-id-index-track___pt",
    path: "track/",
    component: () => import("/root/front/app/pages/draft/[id]/index/track.vue")
  },
  {
    name: "draft-id-index-messages___pt",
    path: "messages/",
    component: () => import("/root/front/app/pages/draft/[id]/index/messages.vue")
  },
  {
    name: "draft-id-index-shared-music___pt",
    path: "shared-music/",
    meta: {"middleware":["draft-shared-music"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/shared-music.vue")
  }
]
  },
  {
    name: "draft-id___it",
    path: "/it/draft/:id()/",
    meta: {"middleware":["is-logged-in","is-band","draft-id","draft-influencers","draft-step"]},
    component: () => import("/root/front/app/pages/draft/[id]/index.vue"),
    children: [
  {
    name: "draft-id-index-recap___it",
    path: "recap/",
    meta: {"middleware":["draft-influencers","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/recap.vue")
  },
  {
    name: "draft-id-index-track___it",
    path: "track/",
    component: () => import("/root/front/app/pages/draft/[id]/index/track.vue")
  },
  {
    name: "draft-id-index-messages___it",
    path: "messages/",
    component: () => import("/root/front/app/pages/draft/[id]/index/messages.vue")
  },
  {
    name: "draft-id-index-shared-music___it",
    path: "shared-music/",
    meta: {"middleware":["draft-shared-music"]},
    component: () => import("/root/front/app/pages/draft/[id]/index/shared-music.vue")
  }
]
  },
  {
    name: "band-create-draft___en",
    path: "/en/band/create-draft/",
    meta: create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta || {},
    component: () => import("/root/front/app/pages/band/create-draft.vue")
  },
  {
    name: "band-create-draft___fr",
    path: "/fr/band/create-draft/",
    meta: create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta || {},
    component: () => import("/root/front/app/pages/band/create-draft.vue")
  },
  {
    name: "band-create-draft___de",
    path: "/de/band/create-draft/",
    meta: create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta || {},
    component: () => import("/root/front/app/pages/band/create-draft.vue")
  },
  {
    name: "band-create-draft___es",
    path: "/es/band/create-draft/",
    meta: create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta || {},
    component: () => import("/root/front/app/pages/band/create-draft.vue")
  },
  {
    name: "band-create-draft___pt",
    path: "/pt/band/create-draft/",
    meta: create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta || {},
    component: () => import("/root/front/app/pages/band/create-draft.vue")
  },
  {
    name: "band-create-draft___it",
    path: "/it/band/create-draft/",
    meta: create_45draftGvV_V9VtZJfGqWy4lSXYvelSbe7W72NJmwrdFiNNeSUMeta || {},
    component: () => import("/root/front/app/pages/band/create-draft.vue")
  },
  {
    name: "band-signup___en",
    path: "/en/band/signup/",
    meta: indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta || {},
    component: () => import("/root/front/app/pages/band/signup/index.vue")
  },
  {
    name: "band-signup___fr",
    path: "/fr/band/signup/",
    meta: indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta || {},
    component: () => import("/root/front/app/pages/band/signup/index.vue")
  },
  {
    name: "band-signup___de",
    path: "/de/band/signup/",
    meta: indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta || {},
    component: () => import("/root/front/app/pages/band/signup/index.vue")
  },
  {
    name: "band-signup___es",
    path: "/es/band/signup/",
    meta: indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta || {},
    component: () => import("/root/front/app/pages/band/signup/index.vue")
  },
  {
    name: "band-signup___pt",
    path: "/pt/band/signup/",
    meta: indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta || {},
    component: () => import("/root/front/app/pages/band/signup/index.vue")
  },
  {
    name: "band-signup___it",
    path: "/it/band/signup/",
    meta: indexYXEXQlScPoga8wMSyBsrttEqFVWxI648YPsUPQ_9n3AMeta || {},
    component: () => import("/root/front/app/pages/band/signup/index.vue")
  },
  {
    name: "draft-influencers___en",
    path: "/en/draft/influencers/",
    meta: influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta || {},
    component: () => import("/root/front/app/pages/draft/influencers.vue")
  },
  {
    name: "draft-influencers___fr",
    path: "/fr/draft/influencers/",
    meta: influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta || {},
    component: () => import("/root/front/app/pages/draft/influencers.vue")
  },
  {
    name: "draft-influencers___de",
    path: "/de/draft/influencers/",
    meta: influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta || {},
    component: () => import("/root/front/app/pages/draft/influencers.vue")
  },
  {
    name: "draft-influencers___es",
    path: "/es/draft/influencers/",
    meta: influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta || {},
    component: () => import("/root/front/app/pages/draft/influencers.vue")
  },
  {
    name: "draft-influencers___pt",
    path: "/pt/draft/influencers/",
    meta: influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta || {},
    component: () => import("/root/front/app/pages/draft/influencers.vue")
  },
  {
    name: "draft-influencers___it",
    path: "/it/draft/influencers/",
    meta: influencers0ogRf9G_s6HzTDx6_n9ceZlBz6Fv5CXBiCkle_Tt7zkMeta || {},
    component: () => import("/root/front/app/pages/draft/influencers.vue")
  },
  {
    name: walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta?.name,
    path: "/en/influencer/wallet/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/wallet.vue"),
    children: [
  {
    name: "influencer-wallet___en",
    path: "",
    component: () => import("/root/front/app/pages/influencer/wallet/index.vue")
  },
  {
    name: "influencer-wallet-transfer___en",
    path: "transfer/",
    component: () => import("/root/front/app/pages/influencer/wallet/transfer.vue")
  },
  {
    name: "influencer-wallet-withdraw___en",
    path: "withdraw/",
    component: () => import("/root/front/app/pages/influencer/wallet/withdraw.vue")
  }
]
  },
  {
    name: walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta?.name,
    path: "/fr/influencer/wallet/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/wallet.vue"),
    children: [
  {
    name: "influencer-wallet___fr",
    path: "",
    component: () => import("/root/front/app/pages/influencer/wallet/index.vue")
  },
  {
    name: "influencer-wallet-transfer___fr",
    path: "transfer/",
    component: () => import("/root/front/app/pages/influencer/wallet/transfer.vue")
  },
  {
    name: "influencer-wallet-withdraw___fr",
    path: "withdraw/",
    component: () => import("/root/front/app/pages/influencer/wallet/withdraw.vue")
  }
]
  },
  {
    name: walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta?.name,
    path: "/de/influencer/wallet/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/wallet.vue"),
    children: [
  {
    name: "influencer-wallet___de",
    path: "",
    component: () => import("/root/front/app/pages/influencer/wallet/index.vue")
  },
  {
    name: "influencer-wallet-transfer___de",
    path: "transfer/",
    component: () => import("/root/front/app/pages/influencer/wallet/transfer.vue")
  },
  {
    name: "influencer-wallet-withdraw___de",
    path: "withdraw/",
    component: () => import("/root/front/app/pages/influencer/wallet/withdraw.vue")
  }
]
  },
  {
    name: walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta?.name,
    path: "/es/influencer/wallet/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/wallet.vue"),
    children: [
  {
    name: "influencer-wallet___es",
    path: "",
    component: () => import("/root/front/app/pages/influencer/wallet/index.vue")
  },
  {
    name: "influencer-wallet-transfer___es",
    path: "transfer/",
    component: () => import("/root/front/app/pages/influencer/wallet/transfer.vue")
  },
  {
    name: "influencer-wallet-withdraw___es",
    path: "withdraw/",
    component: () => import("/root/front/app/pages/influencer/wallet/withdraw.vue")
  }
]
  },
  {
    name: walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta?.name,
    path: "/pt/influencer/wallet/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/wallet.vue"),
    children: [
  {
    name: "influencer-wallet___pt",
    path: "",
    component: () => import("/root/front/app/pages/influencer/wallet/index.vue")
  },
  {
    name: "influencer-wallet-transfer___pt",
    path: "transfer/",
    component: () => import("/root/front/app/pages/influencer/wallet/transfer.vue")
  },
  {
    name: "influencer-wallet-withdraw___pt",
    path: "withdraw/",
    component: () => import("/root/front/app/pages/influencer/wallet/withdraw.vue")
  }
]
  },
  {
    name: walletUeQ_IelMvONDzzluoFFgtBBO2nYMpyJameUxAJ3IqZ4Meta?.name,
    path: "/it/influencer/wallet/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/wallet.vue"),
    children: [
  {
    name: "influencer-wallet___it",
    path: "",
    component: () => import("/root/front/app/pages/influencer/wallet/index.vue")
  },
  {
    name: "influencer-wallet-transfer___it",
    path: "transfer/",
    component: () => import("/root/front/app/pages/influencer/wallet/transfer.vue")
  },
  {
    name: "influencer-wallet-withdraw___it",
    path: "withdraw/",
    component: () => import("/root/front/app/pages/influencer/wallet/withdraw.vue")
  }
]
  },
  {
    name: "band-profile___en",
    path: "/en/band/profile/",
    meta: indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta || {},
    component: () => import("/root/front/app/pages/band/profile/index.vue")
  },
  {
    name: "band-profile___fr",
    path: "/fr/band/profile/",
    meta: indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta || {},
    component: () => import("/root/front/app/pages/band/profile/index.vue")
  },
  {
    name: "band-profile___de",
    path: "/de/band/profile/",
    meta: indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta || {},
    component: () => import("/root/front/app/pages/band/profile/index.vue")
  },
  {
    name: "band-profile___es",
    path: "/es/band/profile/",
    meta: indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta || {},
    component: () => import("/root/front/app/pages/band/profile/index.vue")
  },
  {
    name: "band-profile___pt",
    path: "/pt/band/profile/",
    meta: indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta || {},
    component: () => import("/root/front/app/pages/band/profile/index.vue")
  },
  {
    name: "band-profile___it",
    path: "/it/band/profile/",
    meta: indexyy7_qJyM6HQtgcIrnost0ICmM9EqbIj_Zy1cqT42eIAMeta || {},
    component: () => import("/root/front/app/pages/band/profile/index.vue")
  },
  {
    name: "draft-id-post3ds___en",
    path: "/en/draft/:id()/post3ds/",
    meta: post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/post3ds.vue")
  },
  {
    name: "draft-id-post3ds___fr",
    path: "/fr/draft/:id()/post3ds/",
    meta: post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/post3ds.vue")
  },
  {
    name: "draft-id-post3ds___de",
    path: "/de/draft/:id()/post3ds/",
    meta: post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/post3ds.vue")
  },
  {
    name: "draft-id-post3ds___es",
    path: "/es/draft/:id()/post3ds/",
    meta: post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/post3ds.vue")
  },
  {
    name: "draft-id-post3ds___pt",
    path: "/pt/draft/:id()/post3ds/",
    meta: post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/post3ds.vue")
  },
  {
    name: "draft-id-post3ds___it",
    path: "/it/draft/:id()/post3ds/",
    meta: post3dsBmRZQVx1azCWNkVhMxJl6jmlKXrGFt1G2f5TM070ZPcMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/post3ds.vue")
  },
  {
    name: "influencer-cashout___en",
    path: "/en/influencer/cashout/",
    meta: cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta || {},
    component: () => import("/root/front/app/pages/influencer/cashout.vue")
  },
  {
    name: "influencer-cashout___fr",
    path: "/fr/influencer/cashout/",
    meta: cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta || {},
    component: () => import("/root/front/app/pages/influencer/cashout.vue")
  },
  {
    name: "influencer-cashout___de",
    path: "/de/influencer/cashout/",
    meta: cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta || {},
    component: () => import("/root/front/app/pages/influencer/cashout.vue")
  },
  {
    name: "influencer-cashout___es",
    path: "/es/influencer/cashout/",
    meta: cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta || {},
    component: () => import("/root/front/app/pages/influencer/cashout.vue")
  },
  {
    name: "influencer-cashout___pt",
    path: "/pt/influencer/cashout/",
    meta: cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta || {},
    component: () => import("/root/front/app/pages/influencer/cashout.vue")
  },
  {
    name: "influencer-cashout___it",
    path: "/it/influencer/cashout/",
    meta: cashoutnXE3lobFCH66FBynwSiAS_NQtVzG0ZXmFhzptgPXylQMeta || {},
    component: () => import("/root/front/app/pages/influencer/cashout.vue")
  },
  {
    name: "payin-paypal-retry___en",
    path: "/en/payin/paypal/retry/",
    component: () => import("/root/front/app/pages/payin/paypal/retry.vue")
  },
  {
    name: "payin-paypal-retry___fr",
    path: "/fr/payin/paypal/retry/",
    component: () => import("/root/front/app/pages/payin/paypal/retry.vue")
  },
  {
    name: "payin-paypal-retry___de",
    path: "/de/payin/paypal/retry/",
    component: () => import("/root/front/app/pages/payin/paypal/retry.vue")
  },
  {
    name: "payin-paypal-retry___es",
    path: "/es/payin/paypal/retry/",
    component: () => import("/root/front/app/pages/payin/paypal/retry.vue")
  },
  {
    name: "payin-paypal-retry___pt",
    path: "/pt/payin/paypal/retry/",
    component: () => import("/root/front/app/pages/payin/paypal/retry.vue")
  },
  {
    name: "payin-paypal-retry___it",
    path: "/it/payin/paypal/retry/",
    component: () => import("/root/front/app/pages/payin/paypal/retry.vue")
  },
  {
    name: "band-profile-create___en",
    path: "/en/band/profile/create/",
    meta: {"middleware":["is-logged-in","is-agency"]},
    component: () => import("/root/front/app/pages/band/profile/create.vue")
  },
  {
    name: "band-profile-create___fr",
    path: "/fr/band/profile/create/",
    meta: {"middleware":["is-logged-in","is-agency"]},
    component: () => import("/root/front/app/pages/band/profile/create.vue")
  },
  {
    name: "band-profile-create___de",
    path: "/de/band/profile/create/",
    meta: {"middleware":["is-logged-in","is-agency"]},
    component: () => import("/root/front/app/pages/band/profile/create.vue")
  },
  {
    name: "band-profile-create___es",
    path: "/es/band/profile/create/",
    meta: {"middleware":["is-logged-in","is-agency"]},
    component: () => import("/root/front/app/pages/band/profile/create.vue")
  },
  {
    name: "band-profile-create___pt",
    path: "/pt/band/profile/create/",
    meta: {"middleware":["is-logged-in","is-agency"]},
    component: () => import("/root/front/app/pages/band/profile/create.vue")
  },
  {
    name: "band-profile-create___it",
    path: "/it/band/profile/create/",
    meta: {"middleware":["is-logged-in","is-agency"]},
    component: () => import("/root/front/app/pages/band/profile/create.vue")
  },
  {
    name: "band-profile-delete___en",
    path: "/en/band/profile/delete/",
    meta: deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta || {},
    component: () => import("/root/front/app/pages/band/profile/delete.vue")
  },
  {
    name: "band-profile-delete___fr",
    path: "/fr/band/profile/delete/",
    meta: deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta || {},
    component: () => import("/root/front/app/pages/band/profile/delete.vue")
  },
  {
    name: "band-profile-delete___de",
    path: "/de/band/profile/delete/",
    meta: deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta || {},
    component: () => import("/root/front/app/pages/band/profile/delete.vue")
  },
  {
    name: "band-profile-delete___es",
    path: "/es/band/profile/delete/",
    meta: deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta || {},
    component: () => import("/root/front/app/pages/band/profile/delete.vue")
  },
  {
    name: "band-profile-delete___pt",
    path: "/pt/band/profile/delete/",
    meta: deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta || {},
    component: () => import("/root/front/app/pages/band/profile/delete.vue")
  },
  {
    name: "band-profile-delete___it",
    path: "/it/band/profile/delete/",
    meta: deleteB_P1y5T5O0GBxMOtrkcrVaSeHZ_L5HHOxGhKxoWKJs0Meta || {},
    component: () => import("/root/front/app/pages/band/profile/delete.vue")
  },
  {
    name: "band-profile-select___en",
    path: "/en/band/profile/select/",
    meta: selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta || {},
    component: () => import("/root/front/app/pages/band/profile/select.vue")
  },
  {
    name: "band-profile-select___fr",
    path: "/fr/band/profile/select/",
    meta: selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta || {},
    component: () => import("/root/front/app/pages/band/profile/select.vue")
  },
  {
    name: "band-profile-select___de",
    path: "/de/band/profile/select/",
    meta: selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta || {},
    component: () => import("/root/front/app/pages/band/profile/select.vue")
  },
  {
    name: "band-profile-select___es",
    path: "/es/band/profile/select/",
    meta: selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta || {},
    component: () => import("/root/front/app/pages/band/profile/select.vue")
  },
  {
    name: "band-profile-select___pt",
    path: "/pt/band/profile/select/",
    meta: selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta || {},
    component: () => import("/root/front/app/pages/band/profile/select.vue")
  },
  {
    name: "band-profile-select___it",
    path: "/it/band/profile/select/",
    meta: selectDURO0NVvwuzTgI1nWL5tFUkLffg8uN7hT1yqKOqCIL4Meta || {},
    component: () => import("/root/front/app/pages/band/profile/select.vue")
  },
  {
    name: "band-referral___en",
    path: "/en/band/referral/",
    meta: indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta || {},
    component: () => import("/root/front/app/pages/band/referral/index.vue")
  },
  {
    name: "band-referral___fr",
    path: "/fr/band/referral/",
    meta: indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta || {},
    component: () => import("/root/front/app/pages/band/referral/index.vue")
  },
  {
    name: "band-referral___de",
    path: "/de/band/referral/",
    meta: indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta || {},
    component: () => import("/root/front/app/pages/band/referral/index.vue")
  },
  {
    name: "band-referral___es",
    path: "/es/band/referral/",
    meta: indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta || {},
    component: () => import("/root/front/app/pages/band/referral/index.vue")
  },
  {
    name: "band-referral___pt",
    path: "/pt/band/referral/",
    meta: indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta || {},
    component: () => import("/root/front/app/pages/band/referral/index.vue")
  },
  {
    name: "band-referral___it",
    path: "/it/band/referral/",
    meta: indexCHOpz_UwV0vxeVr99rt_kTLYHZ4o1IkEejIQdf2huvAMeta || {},
    component: () => import("/root/front/app/pages/band/referral/index.vue")
  },
  {
    name: "band-shop-finalized___en",
    path: "/en/band/shop/finalized/",
    meta: finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta || {},
    component: () => import("/root/front/app/pages/band/shop/finalized.vue")
  },
  {
    name: "band-shop-finalized___fr",
    path: "/fr/band/shop/finalized/",
    meta: finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta || {},
    component: () => import("/root/front/app/pages/band/shop/finalized.vue")
  },
  {
    name: "band-shop-finalized___de",
    path: "/de/band/shop/finalized/",
    meta: finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta || {},
    component: () => import("/root/front/app/pages/band/shop/finalized.vue")
  },
  {
    name: "band-shop-finalized___es",
    path: "/es/band/shop/finalized/",
    meta: finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta || {},
    component: () => import("/root/front/app/pages/band/shop/finalized.vue")
  },
  {
    name: "band-shop-finalized___pt",
    path: "/pt/band/shop/finalized/",
    meta: finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta || {},
    component: () => import("/root/front/app/pages/band/shop/finalized.vue")
  },
  {
    name: "band-shop-finalized___it",
    path: "/it/band/shop/finalized/",
    meta: finalizedX_OOINRSA4TwyVH9PD8phngZVPJh5aCLW_ceMLM_EisMeta || {},
    component: () => import("/root/front/app/pages/band/shop/finalized.vue")
  },
  {
    name: "influencer-activate___en",
    path: "/en/influencer/activate/",
    meta: activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta || {},
    component: () => import("/root/front/app/pages/influencer/activate.vue")
  },
  {
    name: "influencer-activate___fr",
    path: "/fr/influencer/activate/",
    meta: activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta || {},
    component: () => import("/root/front/app/pages/influencer/activate.vue")
  },
  {
    name: "influencer-activate___de",
    path: "/de/influencer/activate/",
    meta: activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta || {},
    component: () => import("/root/front/app/pages/influencer/activate.vue")
  },
  {
    name: "influencer-activate___es",
    path: "/es/influencer/activate/",
    meta: activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta || {},
    component: () => import("/root/front/app/pages/influencer/activate.vue")
  },
  {
    name: "influencer-activate___pt",
    path: "/pt/influencer/activate/",
    meta: activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta || {},
    component: () => import("/root/front/app/pages/influencer/activate.vue")
  },
  {
    name: "influencer-activate___it",
    path: "/it/influencer/activate/",
    meta: activateb8A3IIQhzdqhR__DJJoHSOOIJNI8_FCaiWgOjVP4Hi8Meta || {},
    component: () => import("/root/front/app/pages/influencer/activate.vue")
  },
  {
    name: "spotify-share-track___en",
    path: "/en/spotify/share/track/",
    meta: trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta || {},
    component: () => import("/root/front/app/pages/spotify/share/track.vue")
  },
  {
    name: "spotify-share-track___fr",
    path: "/fr/spotify/share/track/",
    meta: trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta || {},
    component: () => import("/root/front/app/pages/spotify/share/track.vue")
  },
  {
    name: "spotify-share-track___de",
    path: "/de/spotify/share/track/",
    meta: trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta || {},
    component: () => import("/root/front/app/pages/spotify/share/track.vue")
  },
  {
    name: "spotify-share-track___es",
    path: "/es/spotify/share/track/",
    meta: trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta || {},
    component: () => import("/root/front/app/pages/spotify/share/track.vue")
  },
  {
    name: "spotify-share-track___pt",
    path: "/pt/spotify/share/track/",
    meta: trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta || {},
    component: () => import("/root/front/app/pages/spotify/share/track.vue")
  },
  {
    name: "spotify-share-track___it",
    path: "/it/spotify/share/track/",
    meta: trackh_GNuvgLXZHi_mTSwk00XlXApdQLDmTj46ZsMLCXtocMeta || {},
    component: () => import("/root/front/app/pages/spotify/share/track.vue")
  },
  {
    name: "band-referral-code___en",
    path: "/en/band/referral/:code()/",
    meta: _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta || {},
    component: () => import("/root/front/app/pages/band/referral/[code].vue")
  },
  {
    name: "band-referral-code___fr",
    path: "/fr/band/referral/:code()/",
    meta: _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta || {},
    component: () => import("/root/front/app/pages/band/referral/[code].vue")
  },
  {
    name: "band-referral-code___de",
    path: "/de/band/referral/:code()/",
    meta: _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta || {},
    component: () => import("/root/front/app/pages/band/referral/[code].vue")
  },
  {
    name: "band-referral-code___es",
    path: "/es/band/referral/:code()/",
    meta: _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta || {},
    component: () => import("/root/front/app/pages/band/referral/[code].vue")
  },
  {
    name: "band-referral-code___pt",
    path: "/pt/band/referral/:code()/",
    meta: _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta || {},
    component: () => import("/root/front/app/pages/band/referral/[code].vue")
  },
  {
    name: "band-referral-code___it",
    path: "/it/band/referral/:code()/",
    meta: _91code_93FNsxfvQypewq8TuVX7Q9Z_lEuMvDz6mAlGijIl2FQO0Meta || {},
    component: () => import("/root/front/app/pages/band/referral/[code].vue")
  },
  {
    name: "draft-id-finalized___en",
    path: "/en/draft/:id()/finalized/",
    component: () => import("/root/front/app/pages/draft/[id]/finalized.vue")
  },
  {
    name: "draft-id-finalized___fr",
    path: "/fr/draft/:id()/finalized/",
    component: () => import("/root/front/app/pages/draft/[id]/finalized.vue")
  },
  {
    name: "draft-id-finalized___de",
    path: "/de/draft/:id()/finalized/",
    component: () => import("/root/front/app/pages/draft/[id]/finalized.vue")
  },
  {
    name: "draft-id-finalized___es",
    path: "/es/draft/:id()/finalized/",
    component: () => import("/root/front/app/pages/draft/[id]/finalized.vue")
  },
  {
    name: "draft-id-finalized___pt",
    path: "/pt/draft/:id()/finalized/",
    component: () => import("/root/front/app/pages/draft/[id]/finalized.vue")
  },
  {
    name: "draft-id-finalized___it",
    path: "/it/draft/:id()/finalized/",
    component: () => import("/root/front/app/pages/draft/[id]/finalized.vue")
  },
  {
    name: "influencer-dashboard___en",
    path: "/en/influencer/dashboard/",
    meta: {"middleware":["is-logged-in","is-influencer","influencer-dashboard"]},
    component: () => import("/root/front/app/pages/influencer/dashboard.vue")
  },
  {
    name: "influencer-dashboard___fr",
    path: "/fr/influencer/dashboard/",
    meta: {"middleware":["is-logged-in","is-influencer","influencer-dashboard"]},
    component: () => import("/root/front/app/pages/influencer/dashboard.vue")
  },
  {
    name: "influencer-dashboard___de",
    path: "/de/influencer/dashboard/",
    meta: {"middleware":["is-logged-in","is-influencer","influencer-dashboard"]},
    component: () => import("/root/front/app/pages/influencer/dashboard.vue")
  },
  {
    name: "influencer-dashboard___es",
    path: "/es/influencer/dashboard/",
    meta: {"middleware":["is-logged-in","is-influencer","influencer-dashboard"]},
    component: () => import("/root/front/app/pages/influencer/dashboard.vue")
  },
  {
    name: "influencer-dashboard___pt",
    path: "/pt/influencer/dashboard/",
    meta: {"middleware":["is-logged-in","is-influencer","influencer-dashboard"]},
    component: () => import("/root/front/app/pages/influencer/dashboard.vue")
  },
  {
    name: "influencer-dashboard___it",
    path: "/it/influencer/dashboard/",
    meta: {"middleware":["is-logged-in","is-influencer","influencer-dashboard"]},
    component: () => import("/root/front/app/pages/influencer/dashboard.vue")
  },
  {
    name: "influencer-list-fans___en",
    path: "/en/influencer/list/fans/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/fans.vue")
  },
  {
    name: "influencer-list-fans___fr",
    path: "/fr/influencer/list/fans/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/fans.vue")
  },
  {
    name: "influencer-list-fans___de",
    path: "/de/influencer/list/fans/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/fans.vue")
  },
  {
    name: "influencer-list-fans___es",
    path: "/es/influencer/list/fans/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/fans.vue")
  },
  {
    name: "influencer-list-fans___pt",
    path: "/pt/influencer/list/fans/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/fans.vue")
  },
  {
    name: "influencer-list-fans___it",
    path: "/it/influencer/list/fans/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/fans.vue")
  },
  {
    name: "influencer-parameter___en",
    path: "/en/influencer/parameter/",
    meta: parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta || {},
    component: () => import("/root/front/app/pages/influencer/parameter.vue")
  },
  {
    name: "influencer-parameter___fr",
    path: "/fr/influencer/parameter/",
    meta: parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta || {},
    component: () => import("/root/front/app/pages/influencer/parameter.vue")
  },
  {
    name: "influencer-parameter___de",
    path: "/de/influencer/parameter/",
    meta: parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta || {},
    component: () => import("/root/front/app/pages/influencer/parameter.vue")
  },
  {
    name: "influencer-parameter___es",
    path: "/es/influencer/parameter/",
    meta: parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta || {},
    component: () => import("/root/front/app/pages/influencer/parameter.vue")
  },
  {
    name: "influencer-parameter___pt",
    path: "/pt/influencer/parameter/",
    meta: parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta || {},
    component: () => import("/root/front/app/pages/influencer/parameter.vue")
  },
  {
    name: "influencer-parameter___it",
    path: "/it/influencer/parameter/",
    meta: parameterxvqUj5ZrxD3_ZT6dDgJ8NpaOtggpZ_3ZpjoS7vr6AsMMeta || {},
    component: () => import("/root/front/app/pages/influencer/parameter.vue")
  },
  {
    name: "agency-favorites-id___en",
    path: "/en/agency/favorites/:id()/",
    meta: {"middleware":["is-logged-in","is-band","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/agency/favorites/[id].vue")
  },
  {
    name: "agency-favorites-id___fr",
    path: "/fr/agency/favorites/:id()/",
    meta: {"middleware":["is-logged-in","is-band","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/agency/favorites/[id].vue")
  },
  {
    name: "agency-favorites-id___de",
    path: "/de/agency/favorites/:id()/",
    meta: {"middleware":["is-logged-in","is-band","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/agency/favorites/[id].vue")
  },
  {
    name: "agency-favorites-id___es",
    path: "/es/agency/favorites/:id()/",
    meta: {"middleware":["is-logged-in","is-band","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/agency/favorites/[id].vue")
  },
  {
    name: "agency-favorites-id___pt",
    path: "/pt/agency/favorites/:id()/",
    meta: {"middleware":["is-logged-in","is-band","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/agency/favorites/[id].vue")
  },
  {
    name: "agency-favorites-id___it",
    path: "/it/agency/favorites/:id()/",
    meta: {"middleware":["is-logged-in","is-band","progressive-promos-check"]},
    component: () => import("/root/front/app/pages/agency/favorites/[id].vue")
  },
  {
    name: "band-signup-discovery___en",
    path: "/en/band/signup/discovery/",
    component: () => import("/root/front/app/pages/band/signup/discovery.vue")
  },
  {
    name: "band-signup-discovery___fr",
    path: "/fr/band/signup/discovery/",
    component: () => import("/root/front/app/pages/band/signup/discovery.vue")
  },
  {
    name: "band-signup-discovery___de",
    path: "/de/band/signup/discovery/",
    component: () => import("/root/front/app/pages/band/signup/discovery.vue")
  },
  {
    name: "band-signup-discovery___es",
    path: "/es/band/signup/discovery/",
    component: () => import("/root/front/app/pages/band/signup/discovery.vue")
  },
  {
    name: "band-signup-discovery___pt",
    path: "/pt/band/signup/discovery/",
    component: () => import("/root/front/app/pages/band/signup/discovery.vue")
  },
  {
    name: "band-signup-discovery___it",
    path: "/it/band/signup/discovery/",
    component: () => import("/root/front/app/pages/band/signup/discovery.vue")
  },
  {
    name: "agency-favorites___en",
    path: "/en/agency/favorites/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/agency/favorites/index.vue")
  },
  {
    name: "agency-favorites___fr",
    path: "/fr/agency/favorites/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/agency/favorites/index.vue")
  },
  {
    name: "agency-favorites___de",
    path: "/de/agency/favorites/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/agency/favorites/index.vue")
  },
  {
    name: "agency-favorites___es",
    path: "/es/agency/favorites/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/agency/favorites/index.vue")
  },
  {
    name: "agency-favorites___pt",
    path: "/pt/agency/favorites/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/agency/favorites/index.vue")
  },
  {
    name: "agency-favorites___it",
    path: "/it/agency/favorites/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/agency/favorites/index.vue")
  },
  {
    name: influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta?.name,
    path: "/en/draft/:id()/influencers/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers.vue"),
    children: [
  {
    name: "draft-id-influencers___en",
    path: "",
    meta: index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/index.vue")
  },
  {
    name: "draft-id-influencers-lists___en",
    path: "lists/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/lists.vue")
  },
  {
    name: "draft-id-influencers-loading___en",
    path: "loading/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers/loading.vue")
  }
]
  },
  {
    name: influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta?.name,
    path: "/fr/draft/:id()/influencers/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers.vue"),
    children: [
  {
    name: "draft-id-influencers___fr",
    path: "",
    meta: index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/index.vue")
  },
  {
    name: "draft-id-influencers-lists___fr",
    path: "lists/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/lists.vue")
  },
  {
    name: "draft-id-influencers-loading___fr",
    path: "loading/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers/loading.vue")
  }
]
  },
  {
    name: influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta?.name,
    path: "/de/draft/:id()/influencers/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers.vue"),
    children: [
  {
    name: "draft-id-influencers___de",
    path: "",
    meta: index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/index.vue")
  },
  {
    name: "draft-id-influencers-lists___de",
    path: "lists/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/lists.vue")
  },
  {
    name: "draft-id-influencers-loading___de",
    path: "loading/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers/loading.vue")
  }
]
  },
  {
    name: influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta?.name,
    path: "/es/draft/:id()/influencers/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers.vue"),
    children: [
  {
    name: "draft-id-influencers___es",
    path: "",
    meta: index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/index.vue")
  },
  {
    name: "draft-id-influencers-lists___es",
    path: "lists/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/lists.vue")
  },
  {
    name: "draft-id-influencers-loading___es",
    path: "loading/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers/loading.vue")
  }
]
  },
  {
    name: influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta?.name,
    path: "/pt/draft/:id()/influencers/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers.vue"),
    children: [
  {
    name: "draft-id-influencers___pt",
    path: "",
    meta: index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/index.vue")
  },
  {
    name: "draft-id-influencers-lists___pt",
    path: "lists/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/lists.vue")
  },
  {
    name: "draft-id-influencers-loading___pt",
    path: "loading/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers/loading.vue")
  }
]
  },
  {
    name: influencersfQQYZDQEz1wJrnh7tVze5vItjA4Oc0WjGRrzLRqLuJEMeta?.name,
    path: "/it/draft/:id()/influencers/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers.vue"),
    children: [
  {
    name: "draft-id-influencers___it",
    path: "",
    meta: index_TjHvz1cE92A5rJkfdWNLO7KphXzoWB9spYVnGCMfikMeta || {},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/index.vue")
  },
  {
    name: "draft-id-influencers-lists___it",
    path: "lists/",
    meta: {"middleware":["is-logged-in","is-band"]},
    component: () => import("/root/front/app/pages/draft/[id]/influencers/lists.vue")
  },
  {
    name: "draft-id-influencers-loading___it",
    path: "loading/",
    component: () => import("/root/front/app/pages/draft/[id]/influencers/loading.vue")
  }
]
  },
  {
    name: "influencer-list-popular___en",
    path: "/en/influencer/list/popular/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/popular.vue")
  },
  {
    name: "influencer-list-popular___fr",
    path: "/fr/influencer/list/popular/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/popular.vue")
  },
  {
    name: "influencer-list-popular___de",
    path: "/de/influencer/list/popular/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/popular.vue")
  },
  {
    name: "influencer-list-popular___es",
    path: "/es/influencer/list/popular/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/popular.vue")
  },
  {
    name: "influencer-list-popular___pt",
    path: "/pt/influencer/list/popular/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/popular.vue")
  },
  {
    name: "influencer-list-popular___it",
    path: "/it/influencer/list/popular/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/popular.vue")
  },
  {
    name: "influencer-signup___en",
    path: "/en/influencer/signup/",
    meta: indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta || {},
    component: () => import("/root/front/app/pages/influencer/signup/index.vue")
  },
  {
    name: "influencer-signup___fr",
    path: "/fr/influencer/signup/",
    meta: indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta || {},
    component: () => import("/root/front/app/pages/influencer/signup/index.vue")
  },
  {
    name: "influencer-signup___de",
    path: "/de/influencer/signup/",
    meta: indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta || {},
    component: () => import("/root/front/app/pages/influencer/signup/index.vue")
  },
  {
    name: "influencer-signup___es",
    path: "/es/influencer/signup/",
    meta: indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta || {},
    component: () => import("/root/front/app/pages/influencer/signup/index.vue")
  },
  {
    name: "influencer-signup___pt",
    path: "/pt/influencer/signup/",
    meta: indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta || {},
    component: () => import("/root/front/app/pages/influencer/signup/index.vue")
  },
  {
    name: "influencer-signup___it",
    path: "/it/influencer/signup/",
    meta: indexgiMaSMuYkzPd1va2ksf3OzTuYU1rsZKXVT9QIDZdCGkMeta || {},
    component: () => import("/root/front/app/pages/influencer/signup/index.vue")
  },
  {
    name: "influencer-widget___en",
    path: "/en/influencer/widget/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/widget/index.vue")
  },
  {
    name: "influencer-widget___fr",
    path: "/fr/influencer/widget/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/widget/index.vue")
  },
  {
    name: "influencer-widget___de",
    path: "/de/influencer/widget/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/widget/index.vue")
  },
  {
    name: "influencer-widget___es",
    path: "/es/influencer/widget/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/widget/index.vue")
  },
  {
    name: "influencer-widget___pt",
    path: "/pt/influencer/widget/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/widget/index.vue")
  },
  {
    name: "influencer-widget___it",
    path: "/it/influencer/widget/",
    meta: {"middleware":["is-logged-in","is-influencer"]},
    component: () => import("/root/front/app/pages/influencer/widget/index.vue")
  },
  {
    name: "band-profile-slug-edit___en",
    path: "/en/band/profile/:slug()/edit/",
    meta: edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta || {},
    component: () => import("/root/front/app/pages/band/profile/[slug]/edit.vue")
  },
  {
    name: "band-profile-slug-edit___fr",
    path: "/fr/band/profile/:slug()/edit/",
    meta: edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta || {},
    component: () => import("/root/front/app/pages/band/profile/[slug]/edit.vue")
  },
  {
    name: "band-profile-slug-edit___de",
    path: "/de/band/profile/:slug()/edit/",
    meta: edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta || {},
    component: () => import("/root/front/app/pages/band/profile/[slug]/edit.vue")
  },
  {
    name: "band-profile-slug-edit___es",
    path: "/es/band/profile/:slug()/edit/",
    meta: edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta || {},
    component: () => import("/root/front/app/pages/band/profile/[slug]/edit.vue")
  },
  {
    name: "band-profile-slug-edit___pt",
    path: "/pt/band/profile/:slug()/edit/",
    meta: edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta || {},
    component: () => import("/root/front/app/pages/band/profile/[slug]/edit.vue")
  },
  {
    name: "band-profile-slug-edit___it",
    path: "/it/band/profile/:slug()/edit/",
    meta: edit32pax6OViHOn64Hz_lzJR4TtFWhenm_5UWsJt3zxveIMeta || {},
    component: () => import("/root/front/app/pages/band/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile___en",
    path: "/en/influencer/profile/",
    meta: indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta || {},
    component: () => import("/root/front/app/pages/influencer/profile/index.vue")
  },
  {
    name: "influencer-profile___fr",
    path: "/fr/influencer/profile/",
    meta: indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta || {},
    component: () => import("/root/front/app/pages/influencer/profile/index.vue")
  },
  {
    name: "influencer-profile___de",
    path: "/de/influencer/profile/",
    meta: indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta || {},
    component: () => import("/root/front/app/pages/influencer/profile/index.vue")
  },
  {
    name: "influencer-profile___es",
    path: "/es/influencer/profile/",
    meta: indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta || {},
    component: () => import("/root/front/app/pages/influencer/profile/index.vue")
  },
  {
    name: "influencer-profile___pt",
    path: "/pt/influencer/profile/",
    meta: indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta || {},
    component: () => import("/root/front/app/pages/influencer/profile/index.vue")
  },
  {
    name: "influencer-profile___it",
    path: "/it/influencer/profile/",
    meta: indexWRgEg98BIOeGz_WQQm0Qk_E_XC343l_yRyg55gGPzX4Meta || {},
    component: () => import("/root/front/app/pages/influencer/profile/index.vue")
  },
  {
    name: "influencer-signup-v2-bio___en",
    path: "/en/influencer/signup/v2/bio/",
    meta: { ...(biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/bio.vue")
  },
  {
    name: "influencer-signup-v2-bio___fr",
    path: "/fr/influencer/signup/v2/bio/",
    meta: { ...(biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/bio.vue")
  },
  {
    name: "influencer-signup-v2-bio___de",
    path: "/de/influencer/signup/v2/bio/",
    meta: { ...(biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/bio.vue")
  },
  {
    name: "influencer-signup-v2-bio___es",
    path: "/es/influencer/signup/v2/bio/",
    meta: { ...(biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/bio.vue")
  },
  {
    name: "influencer-signup-v2-bio___pt",
    path: "/pt/influencer/signup/v2/bio/",
    meta: { ...(biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/bio.vue")
  },
  {
    name: "influencer-signup-v2-bio___it",
    path: "/it/influencer/signup/v2/bio/",
    meta: { ...(biot61Ej_vbaZN5BPkrooqe3NAGCMCDqXXVyLccgWdRNgwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/bio.vue")
  },
  {
    name: "influencer-widget-slug___en",
    path: "/en/influencer/widget/:slug()/",
    meta: _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta || {},
    component: () => import("/root/front/app/pages/influencer/widget/[slug].vue")
  },
  {
    name: "influencer-widget-slug___fr",
    path: "/fr/influencer/widget/:slug()/",
    meta: _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta || {},
    component: () => import("/root/front/app/pages/influencer/widget/[slug].vue")
  },
  {
    name: "influencer-widget-slug___de",
    path: "/de/influencer/widget/:slug()/",
    meta: _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta || {},
    component: () => import("/root/front/app/pages/influencer/widget/[slug].vue")
  },
  {
    name: "influencer-widget-slug___es",
    path: "/es/influencer/widget/:slug()/",
    meta: _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta || {},
    component: () => import("/root/front/app/pages/influencer/widget/[slug].vue")
  },
  {
    name: "influencer-widget-slug___pt",
    path: "/pt/influencer/widget/:slug()/",
    meta: _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta || {},
    component: () => import("/root/front/app/pages/influencer/widget/[slug].vue")
  },
  {
    name: "influencer-widget-slug___it",
    path: "/it/influencer/widget/:slug()/",
    meta: _91slug_934uQ_xVteVE5YMo4PpF8RpqbfrdaIkKMWeDlK8i7ENz0Meta || {},
    component: () => import("/root/front/app/pages/influencer/widget/[slug].vue")
  },
  {
    name: "band-profile-slug___en",
    path: "/en/band/profile/:slug()/",
    component: () => import("/root/front/app/pages/band/profile/[slug]/index.vue")
  },
  {
    name: "band-profile-slug___fr",
    path: "/fr/band/profile/:slug()/",
    component: () => import("/root/front/app/pages/band/profile/[slug]/index.vue")
  },
  {
    name: "band-profile-slug___de",
    path: "/de/band/profile/:slug()/",
    component: () => import("/root/front/app/pages/band/profile/[slug]/index.vue")
  },
  {
    name: "band-profile-slug___es",
    path: "/es/band/profile/:slug()/",
    component: () => import("/root/front/app/pages/band/profile/[slug]/index.vue")
  },
  {
    name: "band-profile-slug___pt",
    path: "/pt/band/profile/:slug()/",
    component: () => import("/root/front/app/pages/band/profile/[slug]/index.vue")
  },
  {
    name: "band-profile-slug___it",
    path: "/it/band/profile/:slug()/",
    component: () => import("/root/front/app/pages/band/profile/[slug]/index.vue")
  },
  {
    name: "influencer-list-all___en",
    path: "/en/influencer/list/all/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/all/index.vue")
  },
  {
    name: "influencer-list-all___fr",
    path: "/fr/influencer/list/all/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/all/index.vue")
  },
  {
    name: "influencer-list-all___de",
    path: "/de/influencer/list/all/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/all/index.vue")
  },
  {
    name: "influencer-list-all___es",
    path: "/es/influencer/list/all/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/all/index.vue")
  },
  {
    name: "influencer-list-all___pt",
    path: "/pt/influencer/list/all/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/all/index.vue")
  },
  {
    name: "influencer-list-all___it",
    path: "/it/influencer/list/all/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/all/index.vue")
  },
  {
    name: "influencer-signup-v2-type___en",
    path: "/en/influencer/signup/v2/type/",
    meta: { ...(typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/type.vue")
  },
  {
    name: "influencer-signup-v2-type___fr",
    path: "/fr/influencer/signup/v2/type/",
    meta: { ...(typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/type.vue")
  },
  {
    name: "influencer-signup-v2-type___de",
    path: "/de/influencer/signup/v2/type/",
    meta: { ...(typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/type.vue")
  },
  {
    name: "influencer-signup-v2-type___es",
    path: "/es/influencer/signup/v2/type/",
    meta: { ...(typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/type.vue")
  },
  {
    name: "influencer-signup-v2-type___pt",
    path: "/pt/influencer/signup/v2/type/",
    meta: { ...(typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/type.vue")
  },
  {
    name: "influencer-signup-v2-type___it",
    path: "/it/influencer/signup/v2/type/",
    meta: { ...(typekLQ7UisQ7U1pXd5_FghGu903RJQhuAdhSDJUOQqblWwMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/type.vue")
  },
  {
    name: "band-edit-track-id___en",
    path: "/en/band/edit/track/:id()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/index.vue")
  },
  {
    name: "band-edit-track-id___fr",
    path: "/fr/band/edit/track/:id()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/index.vue")
  },
  {
    name: "band-edit-track-id___de",
    path: "/de/band/edit/track/:id()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/index.vue")
  },
  {
    name: "band-edit-track-id___es",
    path: "/es/band/edit/track/:id()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/index.vue")
  },
  {
    name: "band-edit-track-id___pt",
    path: "/pt/band/edit/track/:id()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/index.vue")
  },
  {
    name: "band-edit-track-id___it",
    path: "/it/band/edit/track/:id()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/index.vue")
  },
  {
    name: "band-shop-processing-stripe___en",
    path: "/en/band/shop/processing/stripe/",
    component: () => import("/root/front/app/pages/band/shop/processing/stripe.vue")
  },
  {
    name: "band-shop-processing-stripe___fr",
    path: "/fr/band/shop/processing/stripe/",
    component: () => import("/root/front/app/pages/band/shop/processing/stripe.vue")
  },
  {
    name: "band-shop-processing-stripe___de",
    path: "/de/band/shop/processing/stripe/",
    component: () => import("/root/front/app/pages/band/shop/processing/stripe.vue")
  },
  {
    name: "band-shop-processing-stripe___es",
    path: "/es/band/shop/processing/stripe/",
    component: () => import("/root/front/app/pages/band/shop/processing/stripe.vue")
  },
  {
    name: "band-shop-processing-stripe___pt",
    path: "/pt/band/shop/processing/stripe/",
    component: () => import("/root/front/app/pages/band/shop/processing/stripe.vue")
  },
  {
    name: "band-shop-processing-stripe___it",
    path: "/it/band/shop/processing/stripe/",
    component: () => import("/root/front/app/pages/band/shop/processing/stripe.vue")
  },
  {
    name: "influencer-signup-discovery___en",
    path: "/en/influencer/signup/discovery/",
    component: () => import("/root/front/app/pages/influencer/signup/discovery.vue")
  },
  {
    name: "influencer-signup-discovery___fr",
    path: "/fr/influencer/signup/discovery/",
    component: () => import("/root/front/app/pages/influencer/signup/discovery.vue")
  },
  {
    name: "influencer-signup-discovery___de",
    path: "/de/influencer/signup/discovery/",
    component: () => import("/root/front/app/pages/influencer/signup/discovery.vue")
  },
  {
    name: "influencer-signup-discovery___es",
    path: "/es/influencer/signup/discovery/",
    component: () => import("/root/front/app/pages/influencer/signup/discovery.vue")
  },
  {
    name: "influencer-signup-discovery___pt",
    path: "/pt/influencer/signup/discovery/",
    component: () => import("/root/front/app/pages/influencer/signup/discovery.vue")
  },
  {
    name: "influencer-signup-discovery___it",
    path: "/it/influencer/signup/discovery/",
    component: () => import("/root/front/app/pages/influencer/signup/discovery.vue")
  },
  {
    name: "influencer-signup-v2-genres___en",
    path: "/en/influencer/signup/v2/genres/",
    meta: { ...(genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/genres.vue")
  },
  {
    name: "influencer-signup-v2-genres___fr",
    path: "/fr/influencer/signup/v2/genres/",
    meta: { ...(genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/genres.vue")
  },
  {
    name: "influencer-signup-v2-genres___de",
    path: "/de/influencer/signup/v2/genres/",
    meta: { ...(genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/genres.vue")
  },
  {
    name: "influencer-signup-v2-genres___es",
    path: "/es/influencer/signup/v2/genres/",
    meta: { ...(genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/genres.vue")
  },
  {
    name: "influencer-signup-v2-genres___pt",
    path: "/pt/influencer/signup/v2/genres/",
    meta: { ...(genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/genres.vue")
  },
  {
    name: "influencer-signup-v2-genres___it",
    path: "/it/influencer/signup/v2/genres/",
    meta: { ...(genresgdtVgem8IL2MpAtL4JJYqUtbudzp1jpCL6ig6flh8q4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/genres.vue")
  },
  {
    name: "draft-id-processing-stripe___en",
    path: "/en/draft/:id()/processing/stripe/",
    component: () => import("/root/front/app/pages/draft/[id]/processing/stripe.vue")
  },
  {
    name: "draft-id-processing-stripe___fr",
    path: "/fr/draft/:id()/processing/stripe/",
    component: () => import("/root/front/app/pages/draft/[id]/processing/stripe.vue")
  },
  {
    name: "draft-id-processing-stripe___de",
    path: "/de/draft/:id()/processing/stripe/",
    component: () => import("/root/front/app/pages/draft/[id]/processing/stripe.vue")
  },
  {
    name: "draft-id-processing-stripe___es",
    path: "/es/draft/:id()/processing/stripe/",
    component: () => import("/root/front/app/pages/draft/[id]/processing/stripe.vue")
  },
  {
    name: "draft-id-processing-stripe___pt",
    path: "/pt/draft/:id()/processing/stripe/",
    component: () => import("/root/front/app/pages/draft/[id]/processing/stripe.vue")
  },
  {
    name: "draft-id-processing-stripe___it",
    path: "/it/draft/:id()/processing/stripe/",
    component: () => import("/root/front/app/pages/draft/[id]/processing/stripe.vue")
  },
  {
    name: "influencer-list-new-arrivals___en",
    path: "/en/influencer/list/new-arrivals/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/new-arrivals.vue")
  },
  {
    name: "influencer-list-new-arrivals___fr",
    path: "/fr/influencer/list/new-arrivals/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/new-arrivals.vue")
  },
  {
    name: "influencer-list-new-arrivals___de",
    path: "/de/influencer/list/new-arrivals/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/new-arrivals.vue")
  },
  {
    name: "influencer-list-new-arrivals___es",
    path: "/es/influencer/list/new-arrivals/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/new-arrivals.vue")
  },
  {
    name: "influencer-list-new-arrivals___pt",
    path: "/pt/influencer/list/new-arrivals/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/new-arrivals.vue")
  },
  {
    name: "influencer-list-new-arrivals___it",
    path: "/it/influencer/list/new-arrivals/",
    meta: {"middleware":"get-cart-and-favorites"},
    component: () => import("/root/front/app/pages/influencer/list/new-arrivals.vue")
  },
  {
    name: "influencer-signup-v2-picture___en",
    path: "/en/influencer/signup/v2/picture/",
    meta: { ...(pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/picture.vue")
  },
  {
    name: "influencer-signup-v2-picture___fr",
    path: "/fr/influencer/signup/v2/picture/",
    meta: { ...(pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/picture.vue")
  },
  {
    name: "influencer-signup-v2-picture___de",
    path: "/de/influencer/signup/v2/picture/",
    meta: { ...(pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/picture.vue")
  },
  {
    name: "influencer-signup-v2-picture___es",
    path: "/es/influencer/signup/v2/picture/",
    meta: { ...(pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/picture.vue")
  },
  {
    name: "influencer-signup-v2-picture___pt",
    path: "/pt/influencer/signup/v2/picture/",
    meta: { ...(pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/picture.vue")
  },
  {
    name: "influencer-signup-v2-picture___it",
    path: "/it/influencer/signup/v2/picture/",
    meta: { ...(pictureSKhQ9ugkzBEk0CffjoJDHfWo2lzQqH45FvPfTKC1fF4Meta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/picture.vue")
  },
  {
    name: "influencer-list-tags-slug___en",
    path: "/en/influencer/list/tags/:slug(.*)*/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/tags/[...slug].vue")
  },
  {
    name: "influencer-list-tags-slug___fr",
    path: "/fr/influencer/list/tags/:slug(.*)*/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/tags/[...slug].vue")
  },
  {
    name: "influencer-list-tags-slug___de",
    path: "/de/influencer/list/tags/:slug(.*)*/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/tags/[...slug].vue")
  },
  {
    name: "influencer-list-tags-slug___es",
    path: "/es/influencer/list/tags/:slug(.*)*/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/tags/[...slug].vue")
  },
  {
    name: "influencer-list-tags-slug___pt",
    path: "/pt/influencer/list/tags/:slug(.*)*/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/tags/[...slug].vue")
  },
  {
    name: "influencer-list-tags-slug___it",
    path: "/it/influencer/list/tags/:slug(.*)*/",
    meta: {"middleware":["tag-fetch"]},
    component: () => import("/root/front/app/pages/influencer/list/tags/[...slug].vue")
  },
  {
    name: "influencer-profile-slug-edit___en",
    path: "/en/influencer/profile/:slug()/edit/",
    meta: editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile-slug-edit___fr",
    path: "/fr/influencer/profile/:slug()/edit/",
    meta: editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile-slug-edit___de",
    path: "/de/influencer/profile/:slug()/edit/",
    meta: editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile-slug-edit___es",
    path: "/es/influencer/profile/:slug()/edit/",
    meta: editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile-slug-edit___pt",
    path: "/pt/influencer/profile/:slug()/edit/",
    meta: editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile-slug-edit___it",
    path: "/it/influencer/profile/:slug()/edit/",
    meta: editmeVcEokurSjxVLOpFtSyb43Pqg6Qmm6_gSB2bvLxdhAMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/edit.vue")
  },
  {
    name: "influencer-profile-slug___en",
    path: "/en/influencer/profile/:slug()/",
    meta: index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/index.vue")
  },
  {
    name: "influencer-profile-slug___fr",
    path: "/fr/influencer/profile/:slug()/",
    meta: index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/index.vue")
  },
  {
    name: "influencer-profile-slug___de",
    path: "/de/influencer/profile/:slug()/",
    meta: index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/index.vue")
  },
  {
    name: "influencer-profile-slug___es",
    path: "/es/influencer/profile/:slug()/",
    meta: index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/index.vue")
  },
  {
    name: "influencer-profile-slug___pt",
    path: "/pt/influencer/profile/:slug()/",
    meta: index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/index.vue")
  },
  {
    name: "influencer-profile-slug___it",
    path: "/it/influencer/profile/:slug()/",
    meta: index2gxWR2up5ZmQLBk3M7VmL5x1YfNHDIAYvOdfm2wS6ecMeta || {},
    component: () => import("/root/front/app/pages/influencer/profile/[slug]/index.vue")
  },
  {
    name: "influencer-signup-v2-name-country___en",
    path: "/en/influencer/signup/v2/name-country/",
    meta: { ...(name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/name-country.vue")
  },
  {
    name: "influencer-signup-v2-name-country___fr",
    path: "/fr/influencer/signup/v2/name-country/",
    meta: { ...(name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/name-country.vue")
  },
  {
    name: "influencer-signup-v2-name-country___de",
    path: "/de/influencer/signup/v2/name-country/",
    meta: { ...(name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/name-country.vue")
  },
  {
    name: "influencer-signup-v2-name-country___es",
    path: "/es/influencer/signup/v2/name-country/",
    meta: { ...(name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/name-country.vue")
  },
  {
    name: "influencer-signup-v2-name-country___pt",
    path: "/pt/influencer/signup/v2/name-country/",
    meta: { ...(name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/name-country.vue")
  },
  {
    name: "influencer-signup-v2-name-country___it",
    path: "/it/influencer/signup/v2/name-country/",
    meta: { ...(name_45countrywyPFwvs2014fMLjd1mSN8jI9Z0SKn6q5bcfxIlJH2NIMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/name-country.vue")
  },
  {
    name: "influencer-widget-redirect-slug___en",
    path: "/en/influencer/widget/redirect/:slug()/",
    meta: _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta || {},
    component: () => import("/root/front/app/pages/influencer/widget/redirect/[slug].vue")
  },
  {
    name: "influencer-widget-redirect-slug___fr",
    path: "/fr/influencer/widget/redirect/:slug()/",
    meta: _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta || {},
    component: () => import("/root/front/app/pages/influencer/widget/redirect/[slug].vue")
  },
  {
    name: "influencer-widget-redirect-slug___de",
    path: "/de/influencer/widget/redirect/:slug()/",
    meta: _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta || {},
    component: () => import("/root/front/app/pages/influencer/widget/redirect/[slug].vue")
  },
  {
    name: "influencer-widget-redirect-slug___es",
    path: "/es/influencer/widget/redirect/:slug()/",
    meta: _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta || {},
    component: () => import("/root/front/app/pages/influencer/widget/redirect/[slug].vue")
  },
  {
    name: "influencer-widget-redirect-slug___pt",
    path: "/pt/influencer/widget/redirect/:slug()/",
    meta: _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta || {},
    component: () => import("/root/front/app/pages/influencer/widget/redirect/[slug].vue")
  },
  {
    name: "influencer-widget-redirect-slug___it",
    path: "/it/influencer/widget/redirect/:slug()/",
    meta: _91slug_93L0gis21EBRobft2dz7vrsZOhILBCtzxeG2jUe2OTvIIMeta || {},
    component: () => import("/root/front/app/pages/influencer/widget/redirect/[slug].vue")
  },
  {
    name: "band-signup-referral-agency-code___en",
    path: "/en/band/signup/referral/agency/:code()/",
    meta: _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta || {},
    component: () => import("/root/front/app/pages/band/signup/referral/agency/[code].vue")
  },
  {
    name: "band-signup-referral-agency-code___fr",
    path: "/fr/band/signup/referral/agency/:code()/",
    meta: _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta || {},
    component: () => import("/root/front/app/pages/band/signup/referral/agency/[code].vue")
  },
  {
    name: "band-signup-referral-agency-code___de",
    path: "/de/band/signup/referral/agency/:code()/",
    meta: _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta || {},
    component: () => import("/root/front/app/pages/band/signup/referral/agency/[code].vue")
  },
  {
    name: "band-signup-referral-agency-code___es",
    path: "/es/band/signup/referral/agency/:code()/",
    meta: _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta || {},
    component: () => import("/root/front/app/pages/band/signup/referral/agency/[code].vue")
  },
  {
    name: "band-signup-referral-agency-code___pt",
    path: "/pt/band/signup/referral/agency/:code()/",
    meta: _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta || {},
    component: () => import("/root/front/app/pages/band/signup/referral/agency/[code].vue")
  },
  {
    name: "band-signup-referral-agency-code___it",
    path: "/it/band/signup/referral/agency/:code()/",
    meta: _91code_93rPa5szqNdLlyb6v6DHRkeWwwzS5uYAINfQk_EeYvoHQMeta || {},
    component: () => import("/root/front/app/pages/band/signup/referral/agency/[code].vue")
  },
  {
    name: "influencer-signup-v2-opportunities___en",
    path: "/en/influencer/signup/v2/opportunities/",
    meta: { ...(opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/opportunities.vue")
  },
  {
    name: "influencer-signup-v2-opportunities___fr",
    path: "/fr/influencer/signup/v2/opportunities/",
    meta: { ...(opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/opportunities.vue")
  },
  {
    name: "influencer-signup-v2-opportunities___de",
    path: "/de/influencer/signup/v2/opportunities/",
    meta: { ...(opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/opportunities.vue")
  },
  {
    name: "influencer-signup-v2-opportunities___es",
    path: "/es/influencer/signup/v2/opportunities/",
    meta: { ...(opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/opportunities.vue")
  },
  {
    name: "influencer-signup-v2-opportunities___pt",
    path: "/pt/influencer/signup/v2/opportunities/",
    meta: { ...(opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/opportunities.vue")
  },
  {
    name: "influencer-signup-v2-opportunities___it",
    path: "/it/influencer/signup/v2/opportunities/",
    meta: { ...(opportunitiesdfmNQpKu6IQBR1FpXMWUkG_1gT0E5tYaesCNT_XLQCMMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/opportunities.vue")
  },
  {
    name: "influencer-signup-v2-website-links___en",
    path: "/en/influencer/signup/v2/website-links/",
    meta: { ...(website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/website-links.vue")
  },
  {
    name: "influencer-signup-v2-website-links___fr",
    path: "/fr/influencer/signup/v2/website-links/",
    meta: { ...(website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/website-links.vue")
  },
  {
    name: "influencer-signup-v2-website-links___de",
    path: "/de/influencer/signup/v2/website-links/",
    meta: { ...(website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/website-links.vue")
  },
  {
    name: "influencer-signup-v2-website-links___es",
    path: "/es/influencer/signup/v2/website-links/",
    meta: { ...(website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/website-links.vue")
  },
  {
    name: "influencer-signup-v2-website-links___pt",
    path: "/pt/influencer/signup/v2/website-links/",
    meta: { ...(website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/website-links.vue")
  },
  {
    name: "influencer-signup-v2-website-links___it",
    path: "/it/influencer/signup/v2/website-links/",
    meta: { ...(website_45linkslIfpVDCEU0r5yjrU05ugDvPoY2PTBpikZjnpdTMppUgMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/website-links.vue")
  },
  {
    name: "influencer-signup-v2-similar-artists___en",
    path: "/en/influencer/signup/v2/similar-artists/",
    meta: { ...(similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/similar-artists.vue")
  },
  {
    name: "influencer-signup-v2-similar-artists___fr",
    path: "/fr/influencer/signup/v2/similar-artists/",
    meta: { ...(similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/similar-artists.vue")
  },
  {
    name: "influencer-signup-v2-similar-artists___de",
    path: "/de/influencer/signup/v2/similar-artists/",
    meta: { ...(similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/similar-artists.vue")
  },
  {
    name: "influencer-signup-v2-similar-artists___es",
    path: "/es/influencer/signup/v2/similar-artists/",
    meta: { ...(similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/similar-artists.vue")
  },
  {
    name: "influencer-signup-v2-similar-artists___pt",
    path: "/pt/influencer/signup/v2/similar-artists/",
    meta: { ...(similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/similar-artists.vue")
  },
  {
    name: "influencer-signup-v2-similar-artists___it",
    path: "/it/influencer/signup/v2/similar-artists/",
    meta: { ...(similar_45artistsQe7kFvJZJCarC2WiLN2_Ty_oztPB_U33Iqlpreg9moQMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/similar-artists.vue")
  },
  {
    name: "band-signup-referral-influencer-code___en",
    path: "/en/band/signup/referral/influencer/:code()/",
    component: () => import("/root/front/app/pages/band/signup/referral/influencer/[code].vue")
  },
  {
    name: "band-signup-referral-influencer-code___fr",
    path: "/fr/band/signup/referral/influencer/:code()/",
    component: () => import("/root/front/app/pages/band/signup/referral/influencer/[code].vue")
  },
  {
    name: "band-signup-referral-influencer-code___de",
    path: "/de/band/signup/referral/influencer/:code()/",
    component: () => import("/root/front/app/pages/band/signup/referral/influencer/[code].vue")
  },
  {
    name: "band-signup-referral-influencer-code___es",
    path: "/es/band/signup/referral/influencer/:code()/",
    component: () => import("/root/front/app/pages/band/signup/referral/influencer/[code].vue")
  },
  {
    name: "band-signup-referral-influencer-code___pt",
    path: "/pt/band/signup/referral/influencer/:code()/",
    component: () => import("/root/front/app/pages/band/signup/referral/influencer/[code].vue")
  },
  {
    name: "band-signup-referral-influencer-code___it",
    path: "/it/band/signup/referral/influencer/:code()/",
    component: () => import("/root/front/app/pages/band/signup/referral/influencer/[code].vue")
  },
  {
    name: "influencer-signup-v2-lang-lyrics-release___en",
    path: "/en/influencer/signup/v2/lang-lyrics-release/",
    meta: { ...(lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue")
  },
  {
    name: "influencer-signup-v2-lang-lyrics-release___fr",
    path: "/fr/influencer/signup/v2/lang-lyrics-release/",
    meta: { ...(lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue")
  },
  {
    name: "influencer-signup-v2-lang-lyrics-release___de",
    path: "/de/influencer/signup/v2/lang-lyrics-release/",
    meta: { ...(lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue")
  },
  {
    name: "influencer-signup-v2-lang-lyrics-release___es",
    path: "/es/influencer/signup/v2/lang-lyrics-release/",
    meta: { ...(lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue")
  },
  {
    name: "influencer-signup-v2-lang-lyrics-release___pt",
    path: "/pt/influencer/signup/v2/lang-lyrics-release/",
    meta: { ...(lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue")
  },
  {
    name: "influencer-signup-v2-lang-lyrics-release___it",
    path: "/it/influencer/signup/v2/lang-lyrics-release/",
    meta: { ...(lang_45lyrics_45releaseZuBzhOIivYi0HASxXWMTJOc3i4qZyq_yqA_jZaiQCnYMeta || {}), ...{"middleware":["onboarding-flow"]} },
    component: () => import("/root/front/app/pages/influencer/signup/v2/lang-lyrics-release.vue")
  },
  {
    name: "band-edit-track-id-campaign-campaignId___en",
    path: "/en/band/edit/track/:id()/campaign/:campaignId()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue")
  },
  {
    name: "band-edit-track-id-campaign-campaignId___fr",
    path: "/fr/band/edit/track/:id()/campaign/:campaignId()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue")
  },
  {
    name: "band-edit-track-id-campaign-campaignId___de",
    path: "/de/band/edit/track/:id()/campaign/:campaignId()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue")
  },
  {
    name: "band-edit-track-id-campaign-campaignId___es",
    path: "/es/band/edit/track/:id()/campaign/:campaignId()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue")
  },
  {
    name: "band-edit-track-id-campaign-campaignId___pt",
    path: "/pt/band/edit/track/:id()/campaign/:campaignId()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue")
  },
  {
    name: "band-edit-track-id-campaign-campaignId___it",
    path: "/it/band/edit/track/:id()/campaign/:campaignId()/",
    meta: {"middleware":["is-logged-in","is-band","redirect-missing-id-param"]},
    component: () => import("/root/front/app/pages/band/edit/track/[id]/campaign/[campaignId]/index.vue")
  }
]